// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared enterprise scrollbar — import into dashboard SCSS roots. */
.sales-kpi-dashboard {
  --skd-bg: #f3f4f8;
  --skd-card-radius: 10px;
  --skd-shadow: none;
  --skd-shadow-soft: none;
  --skd-text: #161a3a;
  --skd-muted: #646a8a;
  --skd-border: #e3e5ee;
  --skd-navy: #1b1f4b;
  --skd-scroll-thumb: #9aa8d6;
  --skd-scroll-thumb-hover: #2f5bea;
  --skd-scroll-track: #eef1f8;
  background: var(--skd-bg);
  box-sizing: border-box;
  color: var(--skd-text);
  display: flex;
  flex-direction: column;
  font-family: "Open Sans", "Roboto", Helvetica, Arial, sans-serif;
  font-size: 13.5px;
  gap: 12px;
  line-height: 1.4;
  margin: -20px;
  min-height: calc(100vh - 64px);
  padding: 12px 12px 24px;
  width: auto;
}
.sales-kpi-dashboard .skd-page-header {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 0;
}
.sales-kpi-dashboard .skd-date-filter-bar {
  background: #fff;
  border: 1px solid #e3e5ee;
  border-radius: 10px;
  box-shadow: none;
  flex-wrap: wrap;
  margin-bottom: 0;
  overflow: visible;
  padding: 10px 14px;
  position: relative;
  z-index: 3;
}
.sales-kpi-dashboard .skd-filter-actions {
  align-items: flex-end;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  min-width: 0;
}
.sales-kpi-dashboard .skd-week-filter-wrap {
  flex: 0 0 auto;
  max-width: 100%;
  overflow: visible;
  position: relative;
  width: max-content;
  z-index: 2;
}
.sales-kpi-dashboard .skd-date-filter-wrap {
  flex: 0 1 220px;
  max-width: 100%;
  min-width: 180px;
}
.sales-kpi-dashboard .skd-city-filter-wrap,
.sales-kpi-dashboard .skd-am-filter-wrap {
  display: flex;
  flex: 0 1 220px;
  flex-direction: column;
  gap: 3px;
  max-width: 100%;
  min-width: 180px;
}
.sales-kpi-dashboard .skd-city-filter-wrap > div,
.sales-kpi-dashboard .skd-am-filter-wrap > div {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  width: 100%;
}
.sales-kpi-dashboard .skd-filter-field-label {
  color: #646a8a;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}
.sales-kpi-dashboard .skd-search-btn-wrap {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  padding-top: 15px;
}
.sales-kpi-dashboard .skd-page-title {
  color: #1b1f4b;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.25;
  margin: 0;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-global-search {
  flex: 1 1;
  max-width: 520px;
  position: relative;
}
.sales-kpi-dashboard .skd-global-search input {
  background: #fff;
  border: 1px solid var(--skd-border);
  border-radius: 999px;
  box-shadow: var(--skd-shadow-soft);
  color: var(--skd-text);
  font-size: 13px;
  outline: none;
  padding: 11px 16px 11px 40px;
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
}
.sales-kpi-dashboard .skd-global-search input::placeholder {
  color: #94a3b8;
}
.sales-kpi-dashboard .skd-global-search input:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}
.sales-kpi-dashboard .skd-global-search-icon {
  color: #94a3b8;
  font-size: 18px !important;
  left: 14px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.sales-kpi-dashboard .skd-kpi-grid {
  align-items: stretch;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
  grid-auto-rows: 1fr;
  grid-template-columns: 1fr;
  margin-bottom: 14px;
  width: 100%;
}
.sales-kpi-dashboard .skd-kpi-grid > * {
  min-width: 0;
  width: 100%;
}
@media (min-width: 600px) {
  .sales-kpi-dashboard .skd-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 900px) and (max-width: 1023px) {
  .sales-kpi-dashboard .skd-kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .sales-kpi-dashboard .skd-kpi-grid {
    gap: 6px;
    grid-template-columns: minmax(0, 1.45fr) repeat(5, minmax(0, 1fr));
  }
  .sales-kpi-dashboard .skd-kpi-grid .skd-card--wide {
    grid-column: auto;
  }
}
@media (min-width: 1440px) {
  .sales-kpi-dashboard .skd-kpi-grid {
    gap: 8px;
    grid-template-columns: minmax(0, 1.75fr) repeat(5, minmax(0, 1fr));
  }
}
.sales-kpi-dashboard .skd-section-row {
  margin-bottom: 0;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-section-row > .MuiGrid-item {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 0;
}
.sales-kpi-dashboard .skd-section-row > .MuiGrid-item > * {
  flex: 1 1;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-col-fleet {
  color: #2563eb;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-col-throughput {
  color: #16a34a;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-col-outstanding {
  color: #d97706;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-col-overdue {
  color: #dc2626;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-col-accounts {
  color: #16a34a;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-col-vehicles {
  color: #0891b2;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-card {
  border: 1px solid var(--skd-border);
  border-radius: var(--skd-card-radius);
  box-shadow: var(--skd-shadow);
  container-type: inline-size;
  display: grid;
  grid-template-rows: 14px 26px 16px 1fr auto;
  height: 100%;
  min-height: 118px;
  overflow: hidden;
  padding: 12px 14px 10px;
  grid-row-gap: 4px;
  row-gap: 4px;
  position: relative;
}
.sales-kpi-dashboard .skd-card--revenue {
  background: #1d3461;
  color: #fff;
}
.sales-kpi-dashboard .skd-card--revenue .skd-card-label,
.sales-kpi-dashboard .skd-card--revenue .skd-card-sub,
.sales-kpi-dashboard .skd-card--revenue .skd-card-footer,
.sales-kpi-dashboard .skd-card--revenue .skd-card-unit {
  color: rgba(255, 255, 255, 0.74);
}
.sales-kpi-dashboard .skd-card--revenue .skd-card-label {
  padding-right: 68px;
}
.sales-kpi-dashboard .skd-card--revenue .skd-card-value {
  color: #fff;
}
.sales-kpi-dashboard .skd-card--revenue .skd-progress-track {
  background: rgba(255, 255, 255, 0.22);
  height: 5px;
  overflow: visible;
  position: relative;
}
.sales-kpi-dashboard .skd-card--revenue .skd-progress-fill {
  background: #fff;
  border-radius: 9px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-card--revenue .skd-rev-vs,
.sales-kpi-dashboard .skd-card--revenue .skd-card-mom-prev {
  color: rgba(255, 255, 255, 0.55);
}
.sales-kpi-dashboard .skd-card--revenue .skd-rev-badge {
  background: rgba(255, 255, 255, 0.74);
  color: #1d3461;
}
.sales-kpi-dashboard .skd-card--revenue .skd-mom-badge.is-good {
  color: #7ff0b0;
}
.sales-kpi-dashboard .skd-card--revenue .skd-mom-badge.is-bad {
  color: #ff9b9b;
}
.sales-kpi-dashboard .skd-card--revenue .skd-mom-badge.is-flat {
  color: rgba(255, 255, 255, 0.74);
}
.sales-kpi-dashboard .skd-card--revenue-detail {
  gap: 4px;
  grid-template-rows: auto auto auto 1fr auto;
  min-height: 140px;
  row-gap: 4px;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-sub {
  color: rgba(255, 255, 255, 0.74);
  font-size: 11.5px;
  line-height: 15px;
  overflow: visible;
  text-overflow: initial;
  white-space: normal;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-footer {
  font-size: 11px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-value {
  font-size: clamp(18px, 12cqi, 23px);
  font-weight: 900;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-value-row {
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-after-value {
  align-items: baseline;
  display: inline-flex;
  flex: 1 1 auto;
  gap: 8px;
  min-width: 0;
}
.sales-kpi-dashboard .skd-card--revenue-detail .skd-card-bottom {
  margin-top: auto;
  min-height: 0;
}
.sales-kpi-dashboard .skd-card--throughput {
  background: #0f69a7;
  color: #fff;
}
.sales-kpi-dashboard .skd-card--throughput .skd-card-label,
.sales-kpi-dashboard .skd-card--throughput .skd-card-sub,
.sales-kpi-dashboard .skd-card--throughput .skd-card-footer,
.sales-kpi-dashboard .skd-card--throughput .skd-card-unit {
  color: rgba(255, 255, 255, 0.85);
}
.sales-kpi-dashboard .skd-card--throughput .skd-card-value {
  color: #fff;
}
.sales-kpi-dashboard .skd-card--throughput .skd-progress-track {
  background: rgba(255, 255, 255, 0.22);
}
.sales-kpi-dashboard .skd-card--throughput .skd-progress-fill {
  background: #86efac;
}
.sales-kpi-dashboard .skd-card--fleet {
  background: #15b9bb;
  color: #fff;
}
.sales-kpi-dashboard .skd-card--fleet .skd-card-label,
.sales-kpi-dashboard .skd-card--fleet .skd-card-sub,
.sales-kpi-dashboard .skd-card--fleet .skd-card-footer,
.sales-kpi-dashboard .skd-card--fleet .skd-card-unit {
  color: rgba(255, 255, 255, 0.85);
}
.sales-kpi-dashboard .skd-card--fleet .skd-card-value {
  color: #fff;
}
.sales-kpi-dashboard .skd-card--fleet .skd-progress-track {
  background: rgba(255, 255, 255, 0.22);
}
.sales-kpi-dashboard .skd-card--fleet .skd-progress-fill {
  background: #ecfccb;
}
.sales-kpi-dashboard .skd-card--pms {
  background: #a1d0a2;
  color: #1e3a2f;
}
.sales-kpi-dashboard .skd-card--pms .skd-card-label {
  color: #2d4a3e;
}
.sales-kpi-dashboard .skd-card--pms .skd-card-sub,
.sales-kpi-dashboard .skd-card--pms .skd-card-footer,
.sales-kpi-dashboard .skd-card--pms .skd-card-unit {
  color: #2d4a3e;
}
.sales-kpi-dashboard .skd-card--pms .skd-card-value {
  color: #1a3328;
}
.sales-kpi-dashboard .skd-card--pms .skd-progress-track {
  background: rgba(30, 58, 47, 0.18);
}
.sales-kpi-dashboard .skd-card--pms .skd-progress-fill {
  background: #1a3328;
}
.sales-kpi-dashboard .skd-card--risk {
  background: #fbe9d5;
  color: #7c2d12;
}
.sales-kpi-dashboard .skd-card--risk .skd-card-label {
  color: #9a3412;
}
.sales-kpi-dashboard .skd-card--risk .skd-card-sub,
.sales-kpi-dashboard .skd-card--risk .skd-card-footer,
.sales-kpi-dashboard .skd-card--risk .skd-card-unit {
  color: #9a3412;
}
.sales-kpi-dashboard .skd-card--risk .skd-card-value {
  color: #c2410c;
}
.sales-kpi-dashboard .skd-card--risk .skd-progress-track {
  background: rgba(247, 175, 93, 0.45);
}
.sales-kpi-dashboard .skd-card--risk .skd-progress-fill {
  background: linear-gradient(90deg, #f7af5d, #ef4444);
}
.sales-kpi-dashboard .skd-card--outstanding {
  background: #f7af5d;
  color: #78350f;
}
.sales-kpi-dashboard .skd-card--outstanding .skd-card-label {
  color: #92400e;
}
.sales-kpi-dashboard .skd-card--outstanding .skd-card-sub,
.sales-kpi-dashboard .skd-card--outstanding .skd-card-footer,
.sales-kpi-dashboard .skd-card--outstanding .skd-card-unit {
  color: #92400e;
}
.sales-kpi-dashboard .skd-card--outstanding .skd-card-value {
  color: #7c2d12;
}
.sales-kpi-dashboard .skd-card--outstanding .skd-progress-track {
  background: rgba(120, 53, 15, 0.18);
}
.sales-kpi-dashboard .skd-card--outstanding .skd-progress-fill {
  background: #7c2d12;
}
.sales-kpi-dashboard .skd-card--skeleton {
  background: #fff;
  border: 1px solid var(--skd-border);
  display: flex;
  flex-direction: column;
  grid-template-rows: none;
}
.sales-kpi-dashboard .skd-card-label {
  align-items: center;
  color: var(--skd-muted);
  display: flex;
  font-size: clamp(8px, 5.2cqi, 10px);
  font-weight: 700;
  gap: 4px;
  letter-spacing: 0.06em;
  line-height: 14px;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card-label-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sales-kpi-dashboard .skd-card-info {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  line-height: 0;
  position: relative;
  z-index: 3;
}
.sales-kpi-dashboard .skd-card-info-icon {
  font-size: 13px !important;
}
.sales-kpi-dashboard .skd-card-main {
  align-items: center;
  display: flex;
  min-height: 26px;
  min-width: 0;
}
.sales-kpi-dashboard .skd-card-value-row {
  align-items: baseline;
  display: flex;
  flex: 1 1;
  flex-wrap: nowrap;
  gap: 6px;
  min-width: 0;
}
.sales-kpi-dashboard .skd-card-value {
  color: var(--skd-text);
  flex: 0 0 auto;
  font-size: clamp(13px, 10.5cqi, 22px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card-unit {
  flex: 0 1 auto;
  font-size: clamp(8px, 5.6cqi, 11px);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.2;
  min-width: 0;
  opacity: 0.82;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card-sub {
  color: var(--skd-muted);
  font-size: clamp(8px, 5.4cqi, 11px);
  line-height: 16px;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card-sub svg {
  font-size: 0.95em !important;
  vertical-align: middle;
}
.sales-kpi-dashboard .skd-card-meta {
  align-items: center;
  display: inline-flex;
  gap: 4px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-card-meta strong {
  font-weight: 700;
}
.sales-kpi-dashboard .skd-card--wide .skd-card-sub .skd-card-meta,
.sales-kpi-dashboard .skd-card--wide .skd-card-footer .skd-card-meta {
  display: flex;
  width: 100%;
}
.sales-kpi-dashboard .skd-card-after-value {
  align-items: baseline;
  display: inline-flex;
  min-width: 0;
}
.sales-kpi-dashboard .skd-card-mom-prev {
  font-size: 11px;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-mom-badge {
  flex: 0 0 auto;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-rev-split {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-rev-split-row {
  align-items: baseline;
  grid-column-gap: 7px;
  column-gap: 7px;
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-rev-badge {
  align-self: center;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.05em;
  line-height: 13px;
  padding: 0 4px;
  text-align: center;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-rev-cur {
  color: #fff;
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-rev-vs {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-rev-footer {
  align-items: baseline;
  display: flex;
  gap: 6px;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-rev-ach {
  font-weight: 500;
  opacity: 0.75;
}
.sales-kpi-dashboard .skd-rev-footer-pct {
  flex: none;
  font-style: normal;
  font-weight: 700;
  margin-left: auto;
}
.sales-kpi-dashboard .skd-progress-marker {
  background: #fbbf6b;
  border-radius: 1px;
  height: 11px;
  position: absolute;
  top: -3px;
  width: 2px;
}
.sales-kpi-dashboard .skd-card-bottom {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 28px;
  padding-top: 0;
}
.sales-kpi-dashboard .skd-card-footer {
  color: var(--skd-muted);
  font-size: clamp(8px, 5cqi, 10px);
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 14px;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-sparkline {
  display: block;
  height: 22px;
  opacity: 1;
  pointer-events: none;
  position: absolute;
  right: 8px;
  top: 6px;
  width: 52px;
  z-index: 2;
}
.sales-kpi-dashboard .skd-progress-track {
  background: #e2e8f0;
  border-radius: 999px;
  height: 4px;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.sales-kpi-dashboard .skd-progress-fill {
  background: #22c55e;
  border-radius: 999px;
  height: 100%;
  transition: width 0.4s ease;
}
.sales-kpi-dashboard .skd-positive {
  color: #16a34a;
}
.sales-kpi-dashboard .skd-danger {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-warning {
  color: #d97706;
}
.sales-kpi-dashboard .skd-info {
  color: #2563eb;
}
.sales-kpi-dashboard .skd-card--revenue,
.sales-kpi-dashboard .skd-card--throughput,
.sales-kpi-dashboard .skd-card--fleet,
.sales-kpi-dashboard .skd-card--pms,
.sales-kpi-dashboard .skd-card--risk,
.sales-kpi-dashboard .skd-card--outstanding {
  border-color: transparent;
}
.sales-kpi-dashboard .skd-card--throughput .skd-positive,
.sales-kpi-dashboard .skd-card--throughput .skd-danger,
.sales-kpi-dashboard .skd-card--throughput .skd-info,
.sales-kpi-dashboard .skd-card--fleet .skd-positive,
.sales-kpi-dashboard .skd-card--fleet .skd-danger,
.sales-kpi-dashboard .skd-card--fleet .skd-info {
  color: rgba(255, 255, 255, 0.95);
}
.sales-kpi-dashboard .skd-widget {
  background: #fff;
  border: 1px solid var(--skd-border);
  border-radius: var(--skd-card-radius);
  box-shadow: var(--skd-shadow);
  height: 100%;
  padding: 12px 14px;
}
.sales-kpi-dashboard .skd-widget--fixed-h-lg {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: none;
  min-height: 360px;
  overflow: hidden;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--fixed-h-lg {
    height: 430px;
    max-height: 430px;
    min-height: 430px;
  }
}
.sales-kpi-dashboard .skd-widget--fixed-h-md {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: none;
  min-height: 320px;
  overflow: hidden;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--fixed-h-md {
    height: 400px;
    max-height: 400px;
    min-height: 400px;
  }
}
.sales-kpi-dashboard .skd-widget--risk-panel {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: none;
  min-height: 360px;
  overflow: hidden;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--risk-panel {
    height: 430px;
    max-height: 430px;
    min-height: 430px;
  }
}
.sales-kpi-dashboard .skd-widget--client-directory {
  --mcd-ink: #1f2433;
  --mcd-ink2: #3b4256;
  --mcd-muted: #6b7280;
  --mcd-faint: #9aa1ad;
  --mcd-line: #e8eaf0;
  --mcd-line2: #f0f2f6;
  --mcd-track: #eef0f4;
  --mcd-hover: #f7f9fc;
  --mcd-blue: #2f80ed;
  --mcd-green: #16a34a;
  --mcd-orange: #e07b00;
  --mcd-red: #dc2f2f;
  --mcd-warn: #b45309;
  --mcd-warn-s: #fff4e2;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
  max-height: none;
  min-height: 320px;
  overflow: hidden;
  padding: 16px 16px 10px;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--client-directory {
    height: 480px;
    max-height: 480px;
    min-height: 480px;
  }
}
.sales-kpi-dashboard .skd-widget--penetration-panel, .sales-kpi-dashboard .skd-widget--scorecard-panel {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: none;
  min-height: 320px;
  overflow: hidden;
}
@media (min-width: 900px) {
  .sales-kpi-dashboard .skd-widget--penetration-panel, .sales-kpi-dashboard .skd-widget--scorecard-panel {
    height: 400px;
    max-height: 400px;
    min-height: 400px;
  }
}
.sales-kpi-dashboard .skd-widget--penetration-panel .skd-widget-title, .sales-kpi-dashboard .skd-widget--scorecard-panel .skd-widget-title {
  flex-shrink: 0;
  margin-bottom: 14px;
}
.sales-kpi-dashboard .skd-widget--penetration-panel .skd-penetration-panel-header {
  align-items: center;
  margin-bottom: 14px;
}
.sales-kpi-dashboard .skd-widget--penetration-panel .skd-penetration-panel-header .skd-widget-title {
  margin-bottom: 0;
}
.sales-kpi-dashboard .skd-widget--scorecard-panel .skd-scorecard-panel-header {
  align-items: center;
  margin-bottom: 14px;
}
.sales-kpi-dashboard .skd-widget--scorecard-panel .skd-scorecard-panel-header .skd-widget-title {
  margin-bottom: 0;
}
.sales-kpi-dashboard .skd-widget--product-mix {
  --pmx-ink: #1f2433;
  --pmx-ink2: #3b4256;
  --pmx-muted: #6b7280;
  --pmx-faint: #9aa1ad;
  --pmx-line: #e8eaf0;
  --pmx-track: #eef0f4;
  --pmx-conv: #16a34a;
  --pmx-pend: #f59e0b;
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: auto;
  max-height: none;
  min-height: 320px;
  overflow: hidden;
  padding: 16px;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--product-mix {
    height: 480px;
    max-height: 480px;
    min-height: 480px;
  }
}
.sales-kpi-dashboard .skd-widget--fleet-make-model {
  --fmm-ink: #1f2433;
  --fmm-ink2: #3b4256;
  --fmm-muted: #6b7280;
  --fmm-faint: #9aa1ad;
  --fmm-line: #e8eaf0;
  --fmm-track: #e9ecf2;
  --fmm-hover: #f6f8fc;
  --fmm-blue: #2f80ed;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
  max-height: none;
  min-height: 320px;
  overflow: hidden;
  padding: 16px 14px 12px;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-widget--fleet-make-model {
    height: 480px;
    max-height: 480px;
    min-height: 480px;
  }
}
.sales-kpi-dashboard .skd-penetration-scroll,
.sales-kpi-dashboard .skd-scorecard-scroll {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
  overflow-y: auto;
}
.sales-kpi-dashboard .skd-scorecard-panel-header {
  align-items: center !important;
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 14px;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-scorecard-panel-header .skd-widget-title {
  align-items: center;
  flex: 1 1 auto;
  line-height: 1.2;
  margin-bottom: 0 !important;
  min-width: 0;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-scorecard-panel-header .skd-widget-title > span {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-scorecard-search {
  flex: 0 0 auto;
  width: 150px;
}
.sales-kpi-dashboard .skd-scorecard-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
}
.sales-kpi-dashboard .skd-penetration-row {
  flex-shrink: 0;
}
.sales-kpi-dashboard .skd-penetration-panel-header {
  align-items: center !important;
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 14px;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-penetration-panel-header .skd-widget-title {
  align-items: center;
  flex: 1 1 auto;
  line-height: 1.2;
  margin-bottom: 0 !important;
  min-width: 0;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-penetration-panel-header .skd-widget-title > span {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-penetration-panel-header .skd-penetration-toggle {
  align-self: center;
  flex: 0 0 auto;
  margin-top: 0;
}
.sales-kpi-dashboard .skd-penetration-toggle {
  align-items: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 2px;
  height: 34px;
  padding: 3px;
}
.sales-kpi-dashboard .skd-penetration-tab {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 9px;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  line-height: 1;
  min-width: 34px;
  padding: 0 8px;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}
.sales-kpi-dashboard .skd-penetration-tab .skd-penetration-tab-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: 0;
}
.sales-kpi-dashboard .skd-penetration-tab .skd-penetration-tab-icon .MuiSvgIcon-root {
  display: block;
  font-size: 18px;
}
.sales-kpi-dashboard .skd-penetration-tab:hover:not(.is-active) {
  background: rgba(255, 255, 255, 0.7);
  color: #334155;
}
.sales-kpi-dashboard .skd-penetration-tab.is-active {
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 4px 10px rgba(15, 23, 42, 0.06);
}
.sales-kpi-dashboard .skd-penetration-tab--vehicle.is-active {
  color: #2563eb;
}
.sales-kpi-dashboard .skd-penetration-tab--garage.is-active {
  color: #0f766e;
}
.sales-kpi-dashboard .skd-penetration-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.sales-kpi-dashboard .skd-penetration-name {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}
.sales-kpi-dashboard .skd-penetration-pct {
  font-size: 13px;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-penetration-pct--high {
  color: #16a34a;
}
.sales-kpi-dashboard .skd-penetration-pct--mid {
  color: #d97706;
}
.sales-kpi-dashboard .skd-penetration-pct--low {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-penetration-count {
  font-size: 13px;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-penetration-count.skd-penetration-pct--high {
  color: #16a34a;
}
.sales-kpi-dashboard .skd-penetration-count.skd-penetration-pct--mid {
  color: #d97706;
}
.sales-kpi-dashboard .skd-penetration-count.skd-penetration-pct--low {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-penetration-track {
  background: #e2e8f0;
  border-radius: 999px;
  height: 8px;
  overflow: hidden;
  width: 100%;
}
.sales-kpi-dashboard .skd-penetration-fill {
  border-radius: 999px;
  display: block;
  height: 100%;
  transition: width 0.4s ease;
}
.sales-kpi-dashboard .skd-penetration-fill--high {
  background: linear-gradient(90deg, #22c55e, #16a34a);
}
.sales-kpi-dashboard .skd-penetration-fill--mid {
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
}
.sales-kpi-dashboard .skd-penetration-fill--low {
  background: linear-gradient(90deg, #f87171, #ef4444);
}
.sales-kpi-dashboard .skd-scorecard-table {
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-scorecard-table th,
.sales-kpi-dashboard .skd-scorecard-table td {
  font-size: 12px;
  padding: 8px 6px;
  vertical-align: middle;
}
.sales-kpi-dashboard .skd-scorecard-table th {
  color: var(--skd-muted);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-scorecard-table th.skd-col-accounts,
.sales-kpi-dashboard .skd-scorecard-table td.skd-col-accounts {
  color: #16a34a;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-scorecard-table th.skd-col-vehicles,
.sales-kpi-dashboard .skd-scorecard-table td.skd-col-vehicles {
  color: #0891b2;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-scorecard-table th.skd-col-outstanding,
.sales-kpi-dashboard .skd-scorecard-table td.skd-col-outstanding {
  color: #d97706;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-scorecard-table td.skd-scorecard-outstanding--low {
  color: #b45309;
}
.sales-kpi-dashboard .skd-scorecard-table td.skd-scorecard-outstanding--mid {
  color: #d97706;
}
.sales-kpi-dashboard .skd-scorecard-table td.skd-scorecard-outstanding--high {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-scorecard-table th:nth-child(2),
.sales-kpi-dashboard .skd-scorecard-table th:nth-child(3),
.sales-kpi-dashboard .skd-scorecard-table td:nth-child(2),
.sales-kpi-dashboard .skd-scorecard-table td:nth-child(3) {
  text-align: center;
}
.sales-kpi-dashboard .skd-scorecard-table th:last-child,
.sales-kpi-dashboard .skd-scorecard-table td:last-child {
  text-align: right;
}
.sales-kpi-dashboard .skd-scorecard-table tbody tr {
  border-top: 1px solid #e2e8f0;
}
.sales-kpi-dashboard .skd-scorecard-am {
  color: var(--skd-text);
  font-weight: 600;
  overflow-wrap: anywhere;
  white-space: normal;
}
.sales-kpi-dashboard .skd-scorecard-outstanding {
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-scorecard-outstanding--low {
  color: #b45309;
}
.sales-kpi-dashboard .skd-scorecard-outstanding--mid {
  color: #d97706;
}
.sales-kpi-dashboard .skd-scorecard-outstanding--high {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-risk-panel-header {
  align-items: center !important;
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 10px;
  min-width: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-risk-panel-header .skd-widget-title {
  align-items: center;
  flex: 1 1 auto;
  font-size: 12px;
  gap: 4px;
  letter-spacing: 0.02em;
  line-height: 1.2;
  margin-bottom: 0;
  min-width: 0;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-panel-header .skd-widget-title > span {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-search {
  flex: 0 0 auto;
  width: 130px;
}
.sales-kpi-dashboard .skd-client-directory-header {
  flex-shrink: 0;
  margin-bottom: 10px;
}
.sales-kpi-dashboard .skd-mcd__head {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
.sales-kpi-dashboard .skd-mcd__title {
  color: var(--skd-text);
  color: var(--mcd-ink, var(--skd-text));
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-mcd__tot {
  background: var(--skd-border);
  background: var(--mcd-line, var(--skd-border));
  border: 1px solid var(--skd-border);
  border: 1px solid var(--mcd-line, var(--skd-border));
  border-radius: 10px;
  display: grid;
  flex-shrink: 0;
  grid-gap: 1px;
  gap: 1px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
}
.sales-kpi-dashboard .skd-mcd__tot > div {
  background: #fff;
  min-width: 0;
  padding: 8px 12px;
}
.sales-kpi-dashboard .skd-mcd__tot small {
  color: var(--skd-muted);
  color: var(--mcd-muted, var(--skd-muted));
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-mcd__tot b,
.sales-kpi-dashboard .skd-mcd__tot .skd-mcd__tot-val {
  color: var(--skd-text);
  color: var(--mcd-ink, var(--skd-text));
  display: block;
  font-size: 16px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin-top: 2px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-mcd__tot .skd-mcd__tot-val--out {
  color: var(--mcd-orange);
}
.sales-kpi-dashboard .skd-mcd__tot .skd-mcd__tot-val--od {
  color: var(--mcd-red);
}
.sales-kpi-dashboard .skd-mcd__tools {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
.sales-kpi-dashboard .skd-mcd__search {
  align-items: center;
  border: 1px solid var(--skd-border);
  border: 1px solid var(--mcd-line, var(--skd-border));
  border-radius: 8px;
  color: var(--skd-muted);
  color: var(--mcd-faint, var(--skd-muted));
  display: flex;
  flex: 1 1;
  gap: 8px;
  height: 34px;
  min-width: 0;
  padding: 0 10px;
}
.sales-kpi-dashboard .skd-mcd__search:focus-within {
  border-color: var(--mcd-blue);
}
.sales-kpi-dashboard .skd-mcd__search input {
  background: transparent;
  border: 0;
  color: var(--skd-text);
  color: var(--mcd-ink, var(--skd-text));
  font: inherit;
  font-size: 13px;
  min-width: 0;
  outline: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-mcd__search input::placeholder {
  color: var(--skd-muted);
  color: var(--mcd-faint, var(--skd-muted));
}
.sales-kpi-dashboard .skd-mcd__search-icon {
  color: inherit;
  flex: none;
  font-size: 16px !important;
}
.sales-kpi-dashboard .skd-mcd__sort {
  background: #fff;
  border: 1px solid var(--skd-border);
  border: 1px solid var(--mcd-line, var(--skd-border));
  border-radius: 8px;
  color: var(--skd-text);
  color: var(--mcd-ink2, var(--skd-text));
  cursor: pointer;
  flex: none;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 500;
  height: 34px;
  max-width: 46%;
  padding: 0 8px;
}
.sales-kpi-dashboard .skd-mcd__list {
  flex: 1 1 auto;
  list-style: none;
  margin: 0 -6px;
  min-height: 0;
  padding: 0 6px;
}
.sales-kpi-dashboard .skd-mcd__row {
  border-bottom: 1px solid #f0f2f6;
  border-bottom: 1px solid var(--mcd-line2, #f0f2f6);
  border-radius: 6px;
  display: grid;
  grid-gap: 3px 12px;
  gap: 3px 12px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 10px 8px;
}
.sales-kpi-dashboard .skd-mcd__row:hover {
  background: #f7f9fc;
  background: var(--mcd-hover, #f7f9fc);
}
.sales-kpi-dashboard .skd-mcd__name {
  color: var(--skd-text);
  color: var(--mcd-ink, var(--skd-text));
  display: -webkit-box;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.sales-kpi-dashboard .skd-mcd__od {
  color: var(--skd-muted);
  color: var(--mcd-muted, var(--skd-muted));
  font-size: 12px;
  text-align: right;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-mcd__od b {
  color: var(--mcd-red);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-mcd__meta {
  align-items: center;
  color: var(--skd-muted);
  color: var(--mcd-muted, var(--skd-muted));
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  gap: 6px;
  min-width: 0;
}
.sales-kpi-dashboard .skd-mcd__fl {
  color: var(--mcd-blue);
  font-weight: 600;
}
.sales-kpi-dashboard .skd-mcd__pn {
  color: var(--mcd-green);
  font-weight: 600;
}
.sales-kpi-dashboard .skd-mcd__pn--hi {
  background: var(--mcd-warn-s);
  border-radius: 5px;
  color: var(--mcd-warn);
  padding: 0 5px;
}
.sales-kpi-dashboard .skd-mcd__sep {
  background: var(--skd-muted);
  background: var(--mcd-faint, var(--skd-muted));
  border-radius: 50%;
  display: inline-block;
  height: 3px;
  width: 3px;
}
.sales-kpi-dashboard .skd-mcd__os {
  color: var(--skd-muted);
  color: var(--mcd-muted, var(--skd-muted));
  font-size: 12px;
  text-align: right;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-mcd__os b {
  color: var(--mcd-orange);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}
.sales-kpi-dashboard .skd-mcd__bar {
  background: #eef0f4;
  background: var(--mcd-track, #eef0f4);
  border-radius: 9px;
  grid-column: 1/-1;
  height: 4px;
  margin-top: 3px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-mcd__bar i {
  background: linear-gradient(90deg, #f59e0b, #dc2f2f);
  border-radius: 9px;
  display: block;
  height: 100%;
}
.sales-kpi-dashboard .skd-mcd__empty {
  color: var(--skd-muted);
  color: var(--mcd-muted, var(--skd-muted));
  padding: 28px 8px;
  text-align: center;
}
.sales-kpi-dashboard .skd-mcd__foot {
  color: var(--skd-muted);
  color: var(--mcd-faint, var(--skd-muted));
  display: flex;
  flex-shrink: 0;
  font-size: 12px;
  justify-content: space-between;
  padding-top: 2px;
}
.sales-kpi-dashboard .skd-risk-panel-scroll {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
}
.sales-kpi-dashboard .skd-scroll-area {
  flex: 1 1 auto;
  margin-bottom: 0;
  max-height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #9aa8d6 #eef1f8;
}
.sales-kpi-dashboard .skd-scroll-area::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.sales-kpi-dashboard .skd-scroll-area::-webkit-scrollbar-track {
  background: #eef1f8;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-scroll-area::-webkit-scrollbar-thumb {
  background: #9aa8d6;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #2f5bea;
}
.sales-kpi-dashboard .skd-scroll-area::-webkit-scrollbar-corner {
  background: transparent;
}
.sales-kpi-dashboard .skd-widget-header {
  align-items: flex-start;
  display: flex;
  flex-shrink: 0;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 14px;
}
.sales-kpi-dashboard .skd-widget-title {
  align-items: center;
  color: var(--skd-text);
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 6px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-widget-title--danger {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-widget-info {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  line-height: 0;
  text-transform: none;
}
.sales-kpi-dashboard .skd-widget-info-icon {
  color: var(--skd-muted);
  font-size: 15px !important;
}
.sales-kpi-dashboard .skd-widget-subtitle {
  color: var(--skd-muted);
  font-size: 12px;
  margin-top: 4px;
}
.sales-kpi-dashboard .skd-widget-controls {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 10px;
}
.sales-kpi-dashboard .skd-period-toggle {
  background: #f1f5f9;
  border-radius: 999px;
  display: inline-flex;
  padding: 3px;
}
.sales-kpi-dashboard .skd-period-toggle button {
  background: transparent;
  border: none;
  border-radius: 999px;
  color: var(--skd-muted);
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 12px;
  transition: all 0.2s;
}
.sales-kpi-dashboard .skd-period-toggle button.active {
  background: #334155;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
  color: #fff;
}
.sales-kpi-dashboard .skd-period-toggle button:not(.active):hover {
  color: var(--skd-text);
}
.sales-kpi-dashboard .skd-live-badge {
  align-items: center;
  background: #fff;
  border: 1px solid var(--skd-border);
  border-radius: 999px;
  box-shadow: var(--skd-shadow-soft);
  color: var(--skd-muted);
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  padding: 6px 12px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-live-dot {
  animation: skd-pulse 2s infinite;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);
  height: 8px;
  width: 8px;
}
@keyframes skd-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}
.sales-kpi-dashboard .skd-priority-badge {
  background: #fee2e2;
  border-radius: 999px;
  color: #dc2626;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 5px 12px;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-list-item {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) 100px auto;
  padding: 12px 14px;
}
.sales-kpi-dashboard .skd-risk-client {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  min-width: 0;
}
.sales-kpi-dashboard .skd-risk-account-name {
  color: var(--skd-text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-am {
  color: var(--skd-muted);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-count {
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-risk-bar-wrap {
  min-width: 80px;
  width: 100px;
}
.sales-kpi-dashboard .skd-risk-bar {
  background: #e2e8f0;
  border-radius: 999px;
  height: 6px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-risk-bar span {
  background: linear-gradient(90deg, #fdba74, #ef4444);
  border-radius: 999px;
  display: block;
  height: 100%;
  min-width: 4px;
}
.sales-kpi-dashboard .skd-action-btn {
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: var(--skd-muted);
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 10px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-action-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}
.sales-kpi-dashboard .skd-nudge-btn {
  align-items: center;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.28);
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  gap: 8px;
  justify-content: center;
  margin-top: auto;
  padding: 12px;
  width: 100%;
}
.sales-kpi-dashboard .skd-nudge-btn:hover {
  filter: brightness(1.05);
}
.sales-kpi-dashboard .skd-nudge-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
.sales-kpi-dashboard .skd-pmx__head {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
.sales-kpi-dashboard .skd-pmx__title {
  color: var(--skd-text);
  color: var(--pmx-ink, var(--skd-text));
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  line-height: 1.3;
  margin: 0;
  min-width: 0;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-pmx__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #9aa8d6 #eef1f8;
}
.sales-kpi-dashboard .skd-pmx__body::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.sales-kpi-dashboard .skd-pmx__body::-webkit-scrollbar-track {
  background: #eef1f8;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-pmx__body::-webkit-scrollbar-thumb {
  background: #9aa8d6;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-pmx__body::-webkit-scrollbar-thumb:hover {
  background: #2f5bea;
}
.sales-kpi-dashboard .skd-pmx__body::-webkit-scrollbar-corner {
  background: transparent;
}
.sales-kpi-dashboard .skd-pmx__sec {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 9px;
}
.sales-kpi-dashboard .skd-pmx__sec--pms {
  border-top: 1px solid var(--skd-border);
  border-top: 1px solid var(--pmx-line, var(--skd-border));
  padding-top: 14px;
}
.sales-kpi-dashboard .skd-pmx__label {
  color: var(--skd-muted);
  color: var(--pmx-muted, var(--skd-muted));
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-pmx__bar,
.sales-kpi-dashboard .skd-pmx__cbar {
  background: #eef0f4;
  background: var(--pmx-track, #eef0f4);
  border-radius: 99px;
  display: flex;
  gap: 2px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-pmx__bar i,
.sales-kpi-dashboard .skd-pmx__cbar i {
  display: block;
  height: 100%;
  min-width: 0;
}
.sales-kpi-dashboard .skd-pmx__bar {
  height: 14px;
}
.sales-kpi-dashboard .skd-pmx__bar i {
  min-width: 3px;
}
.sales-kpi-dashboard .skd-pmx__cbar {
  height: 10px;
}
.sales-kpi-dashboard .skd-pmx__leg {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.sales-kpi-dashboard .skd-pmx__leg li {
  align-items: center;
  color: var(--skd-text);
  color: var(--pmx-ink, var(--skd-text));
  display: grid;
  font-size: 13px;
  grid-gap: 8px;
  gap: 8px;
  grid-template-columns: 10px minmax(0, 1fr) auto;
}
.sales-kpi-dashboard .skd-pmx__leg b {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-pmx__leg-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-pmx__dot {
  border-radius: 3px;
  display: block;
  height: 10px;
  width: 10px;
}
.sales-kpi-dashboard .skd-pmx__big {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.sales-kpi-dashboard .skd-pmx__big b {
  color: #16a34a;
  color: var(--pmx-conv, #16a34a);
  font-size: 28px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  line-height: 1;
}
.sales-kpi-dashboard .skd-pmx__big span {
  color: var(--skd-muted);
  color: var(--pmx-muted, var(--skd-muted));
  font-size: 12.5px;
  line-height: 1.35;
}
.sales-kpi-dashboard .skd-pmx__stats {
  display: grid;
  grid-gap: 8px;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
}
.sales-kpi-dashboard .skd-pmx__st {
  border: 1px solid;
  border-radius: 9px;
  min-width: 0;
  padding: 8px 10px;
}
.sales-kpi-dashboard .skd-pmx__st small {
  color: var(--skd-text);
  color: var(--pmx-ink2, var(--skd-text));
  display: block;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.3;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-pmx__st b {
  display: block;
  font-size: 17px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin-top: 2px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-pmx__st em {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  margin-left: 4px;
}
.sales-kpi-dashboard .skd-pmx__st--all {
  align-items: center;
  background: #f0f6ff;
  border-color: #d7e6fb;
  display: flex;
  grid-column: 1/-1;
  justify-content: space-between;
}
.sales-kpi-dashboard .skd-pmx__st--all b {
  font-size: 18px;
  margin-top: 0;
}
.sales-kpi-dashboard .skd-pmx__st--cv {
  background: #effaf3;
  border-color: #cdeedb;
}
.sales-kpi-dashboard .skd-pmx__st--cv em {
  color: #16a34a;
  color: var(--pmx-conv, #16a34a);
}
.sales-kpi-dashboard .skd-pmx__st--pd {
  background: #fff8ee;
  border-color: #fbe3bf;
}
.sales-kpi-dashboard .skd-pmx__st--pd em {
  color: #b45309;
}
.sales-kpi-dashboard .skd-fmm__head {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
}
.sales-kpi-dashboard .skd-fmm__title {
  color: var(--skd-text);
  color: var(--fmm-ink, var(--skd-text));
  flex: 1 1 120px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-fmm__seg {
  background: #f1f3f8;
  border-radius: 10px;
  display: inline-flex;
  flex: none;
  gap: 2px;
  margin-left: auto;
  padding: 3px;
}
.sales-kpi-dashboard .skd-fmm__seg button {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 8px;
  color: var(--skd-muted);
  color: var(--fmm-muted, var(--skd-muted));
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  gap: 4px;
  height: 28px;
  padding: 0 8px;
}
.sales-kpi-dashboard .skd-fmm__seg button.is-active, .sales-kpi-dashboard .skd-fmm__seg button[aria-pressed=true] {
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);
  color: #2f80ed;
  color: var(--fmm-blue, #2f80ed);
}
.sales-kpi-dashboard .skd-fmm__sum {
  align-items: baseline;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 14px;
}
.sales-kpi-dashboard .skd-fmm__big {
  color: var(--skd-text);
  color: var(--fmm-ink, var(--skd-text));
  font-size: 28px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  line-height: 1;
}
.sales-kpi-dashboard .skd-fmm__big small {
  color: var(--skd-muted);
  color: var(--fmm-muted, var(--skd-muted));
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
}
.sales-kpi-dashboard .skd-fmm__meta {
  color: var(--skd-muted);
  color: var(--fmm-muted, var(--skd-muted));
  font-size: 12.5px;
}
.sales-kpi-dashboard .skd-fmm__meta b {
  color: var(--skd-text);
  color: var(--fmm-ink2, var(--skd-text));
  font-weight: 700;
}
.sales-kpi-dashboard .skd-fmm__share {
  background: #e9ecf2;
  background: var(--fmm-track, #e9ecf2);
  border-radius: 99px;
  display: flex;
  flex-shrink: 0;
  gap: 2px;
  height: 12px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-fmm__share:hover i {
  opacity: 0.55;
}
.sales-kpi-dashboard .skd-fmm__share i {
  cursor: pointer;
  display: block;
  height: 100%;
  transition: opacity 0.15s;
}
.sales-kpi-dashboard .skd-fmm__share i:hover {
  opacity: 1;
}
.sales-kpi-dashboard .skd-fmm__legend {
  color: var(--skd-text);
  color: var(--fmm-ink2, var(--skd-text));
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  font-size: 12px;
  gap: 4px 14px;
  margin-top: -6px;
}
.sales-kpi-dashboard .skd-fmm__legend span {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}
.sales-kpi-dashboard .skd-fmm__legend i {
  border-radius: 3px;
  display: inline-block;
  height: 9px;
  width: 9px;
}
.sales-kpi-dashboard .skd-fmm__legend b {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-fmm__search {
  align-items: center;
  border: 1px solid var(--skd-border);
  border: 1px solid var(--fmm-line, var(--skd-border));
  border-radius: 8px;
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
}
.sales-kpi-dashboard .skd-fmm__search:focus-within {
  border-color: #2f80ed;
  border-color: var(--fmm-blue, #2f80ed);
}
.sales-kpi-dashboard .skd-fmm__search input {
  background: transparent;
  border: 0;
  color: var(--skd-text);
  color: var(--fmm-ink, var(--skd-text));
  font: inherit;
  font-size: 13px;
  outline: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-fmm__search input::placeholder {
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
}
.sales-kpi-dashboard .skd-fmm__search-icon {
  color: inherit;
  flex: none;
  font-size: 16px !important;
}
.sales-kpi-dashboard .skd-fmm__list {
  flex: 1 1 auto;
  list-style: none;
  margin: 0 -6px;
  min-height: 0;
  padding: 0 6px;
}
.sales-kpi-dashboard .skd-fmm__row {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 8px;
  color: inherit;
  cursor: pointer;
  display: grid;
  font: inherit;
  grid-gap: 5px 10px;
  gap: 5px 10px;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  padding: 8px 6px;
  text-align: left;
  width: 100%;
}
.sales-kpi-dashboard .skd-fmm__row:hover {
  background: #f6f8fc;
  background: var(--fmm-hover, #f6f8fc);
}
.sales-kpi-dashboard .skd-fmm__row--flat {
  cursor: default;
  grid-template-columns: minmax(0, 1fr) auto;
}
.sales-kpi-dashboard .skd-fmm__row--flat .skd-fmm__bar {
  grid-column: 1/-1;
}
.sales-kpi-dashboard .skd-fmm__row[aria-expanded=true] .skd-fmm__chev {
  color: #2f80ed;
  color: var(--fmm-blue, #2f80ed);
  transform: rotate(90deg);
}
.sales-kpi-dashboard .skd-fmm__chev {
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
  font-size: 18px !important;
  transition: transform 0.15s;
}
.sales-kpi-dashboard .skd-fmm__nm {
  font-size: 14px;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-fmm__nm small {
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
  font-size: 12px;
  font-weight: 400;
  margin-left: 6px;
}
.sales-kpi-dashboard .skd-fmm__val {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-fmm__val small {
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
  display: inline-block;
  font-size: 11.5px;
  font-weight: 500;
  margin-left: 6px;
  min-width: 38px;
  text-align: right;
}
.sales-kpi-dashboard .skd-fmm__bar {
  background: #e9ecf2;
  background: var(--fmm-track, #e9ecf2);
  border-radius: 99px;
  grid-column: 2/-1;
  height: 7px;
  overflow: hidden;
}
.sales-kpi-dashboard .skd-fmm__bar i {
  border-radius: 99px;
  display: block;
  height: 100%;
}
.sales-kpi-dashboard .skd-fmm__sub {
  border-left: 2px solid var(--skd-border);
  border-left: 2px solid var(--fmm-line, var(--skd-border));
  list-style: none;
  margin: 0 0 6px 14px;
  padding: 2px 0 6px 34px;
}
.sales-kpi-dashboard .skd-fmm__sub li {
  align-items: center;
  display: grid;
  font-size: 13px;
  grid-gap: 3px 10px;
  gap: 3px 10px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 5px 6px;
}
.sales-kpi-dashboard .skd-fmm__sub .skd-fmm__val {
  font-weight: 600;
}
.sales-kpi-dashboard .skd-fmm__sub .skd-fmm__bar {
  grid-column: 1/-1;
  height: 5px;
}
.sales-kpi-dashboard .skd-fmm__sub .skd-fmm__bar i {
  opacity: 0.7;
}
.sales-kpi-dashboard .skd-fmm__empty {
  color: var(--skd-muted);
  color: var(--fmm-muted, var(--skd-muted));
  padding: 28px 6px;
  text-align: center;
}
.sales-kpi-dashboard .skd-fmm__foot {
  align-items: center;
  border-top: 1px solid var(--skd-border);
  border-top: 1px solid var(--fmm-line, var(--skd-border));
  color: var(--skd-muted);
  color: var(--fmm-faint, var(--skd-muted));
  display: flex;
  flex-shrink: 0;
  font-size: 12px;
  justify-content: space-between;
  padding-top: 10px;
}
.sales-kpi-dashboard .skd-fmm__foot button {
  background: none;
  border: 0;
  color: #2f80ed;
  color: var(--fmm-blue, #2f80ed);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 4px;
}
.sales-kpi-dashboard .skd-table-toolbar {
  align-items: center;
  display: flex;
  gap: 10px;
}
.sales-kpi-dashboard .skd-filter-select {
  background: #fff;
  border: 1px solid var(--skd-border);
  border-radius: 8px;
  color: var(--skd-muted);
  font-size: 12px;
  font-weight: 600;
  outline: none;
  padding: 8px 10px;
}
.sales-kpi-dashboard .skd-search-wrap {
  position: relative;
  width: 180px;
}
.sales-kpi-dashboard .skd-search-input {
  background: #fff;
  border: 1px solid var(--skd-border);
  border-radius: 8px;
  color: var(--skd-text);
  font-size: 12px;
  outline: none;
  padding: 8px 12px 8px 32px;
  width: 100%;
}
.sales-kpi-dashboard .skd-search-input::placeholder {
  color: #94a3b8;
}
.sales-kpi-dashboard .skd-search-input:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.sales-kpi-dashboard .skd-search-icon {
  color: #94a3b8;
  font-size: 16px !important;
  left: 9px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.sales-kpi-dashboard .skd-table-wrap {
  flex: 1 1 auto;
  margin-top: 0;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #9aa8d6 #eef1f8;
}
.sales-kpi-dashboard .skd-table-wrap::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.sales-kpi-dashboard .skd-table-wrap::-webkit-scrollbar-track {
  background: #eef1f8;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-table-wrap::-webkit-scrollbar-thumb {
  background: #9aa8d6;
  border-radius: 99px;
}
.sales-kpi-dashboard .skd-table-wrap::-webkit-scrollbar-thumb:hover {
  background: #2f5bea;
}
.sales-kpi-dashboard .skd-table-wrap::-webkit-scrollbar-corner {
  background: transparent;
}
.sales-kpi-dashboard .skd-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn {
  align-items: center;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  gap: 2px;
  letter-spacing: 0.06em;
  padding: 0;
  text-transform: uppercase;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn:hover {
  opacity: 0.85;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn--active {
  text-decoration: underline;
  text-underline-offset: 2px;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn--fleet {
  color: #2563eb;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn--throughput {
  color: #16a34a;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn--outstanding {
  color: #d97706;
}
.sales-kpi-dashboard .skd-table .skd-sort-btn--overdue {
  color: #dc2626;
}
.sales-kpi-dashboard .skd-table .skd-sort-indicator {
  font-size: 11px;
  line-height: 1;
}
.sales-kpi-dashboard .skd-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
}
.sales-kpi-dashboard .skd-table th,
.sales-kpi-dashboard .skd-table td {
  font-size: 12px;
  padding: 11px 12px;
  text-align: left;
}
.sales-kpi-dashboard .skd-table th {
  background: #f8fafc;
  border-bottom: 1px solid var(--skd-border);
  box-shadow: 0 1px 0 var(--skd-border);
  color: var(--skd-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.sales-kpi-dashboard .skd-table td {
  border-bottom: 1px solid #f1f5f9;
  color: var(--skd-text);
}
.sales-kpi-dashboard .skd-table th.skd-col-fleet,
.sales-kpi-dashboard .skd-table td.skd-col-fleet {
  color: #2563eb;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-table th.skd-col-throughput,
.sales-kpi-dashboard .skd-table td.skd-col-throughput {
  color: #16a34a;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-table th.skd-col-outstanding,
.sales-kpi-dashboard .skd-table td.skd-col-outstanding {
  color: #d97706;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-table th.skd-col-overdue,
.sales-kpi-dashboard .skd-table td.skd-col-overdue {
  color: #dc2626;
  font-weight: 700;
  width: 100px;
}
.sales-kpi-dashboard .skd-table th.skd-col-accounts,
.sales-kpi-dashboard .skd-table td.skd-col-accounts {
  color: #16a34a;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-table th.skd-col-vehicles,
.sales-kpi-dashboard .skd-table td.skd-col-vehicles {
  color: #0891b2;
  font-weight: 700;
}
.sales-kpi-dashboard .skd-table tbody tr:nth-child(even) td {
  background: #f8fafc;
}
.sales-kpi-dashboard .skd-table tbody tr:hover td {
  background: #eff6ff;
}
.sales-kpi-dashboard .skd-view-btn {
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: var(--skd-muted);
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
}
.sales-kpi-dashboard .skd-view-btn:hover {
  background: #f8fafc;
}
.sales-kpi-dashboard .skd-ar-layout {
  container-type: inline-size;
  display: grid;
  grid-gap: 6px;
  gap: 6px;
  grid-template-rows: auto minmax(0, 1fr) auto;
  height: auto;
  max-height: none;
  max-width: 100%;
  min-height: 300px;
  min-width: 0;
  overflow: hidden;
  padding: 12px 14px 10px;
}
@media (min-width: 1200px) {
  .sales-kpi-dashboard .skd-ar-layout.skd-widget--fixed-h-md {
    height: 400px;
    max-height: 400px;
    min-height: 400px;
  }
}
.sales-kpi-dashboard .skd-ar-title {
  grid-row: 1;
  line-height: 1.2;
  margin: 0;
  text-align: left;
}
.sales-kpi-dashboard .skd-ar-chart-wrap {
  align-items: center;
  display: flex;
  grid-row: 2;
  height: 180px;
  justify-content: center;
  line-height: 0;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.sales-kpi-dashboard .skd-ar-chart-wrap > div,
.sales-kpi-dashboard .skd-ar-chart-wrap .highcharts-container,
.sales-kpi-dashboard .skd-ar-chart-wrap .highcharts-root,
.sales-kpi-dashboard .skd-ar-chart-wrap svg {
  max-width: 100% !important;
}
.sales-kpi-dashboard .skd-ar-chart-wrap > div,
.sales-kpi-dashboard .skd-ar-chart-wrap .highcharts-container {
  height: 180px !important;
  width: 100% !important;
}
.sales-kpi-dashboard .skd-ar-legend {
  display: none;
}
.sales-kpi-dashboard .skd-ar-stats-side {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 6px;
  grid-row: 3;
  margin-top: 0;
}
.sales-kpi-dashboard .skd-ar-stat-card {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  min-height: 36px;
  padding: 8px 10px;
  transition: box-shadow 0.2s ease;
}
.sales-kpi-dashboard .skd-ar-stat-card:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}
.sales-kpi-dashboard .skd-ar-stat-card--outstanding {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #b45309;
}
.sales-kpi-dashboard .skd-ar-stat-card--outstanding .skd-ar-stat-icon {
  background: #f59e0b;
}
.sales-kpi-dashboard .skd-ar-stat-card--overdue {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}
.sales-kpi-dashboard .skd-ar-stat-card--overdue .skd-ar-stat-icon {
  background: #ef4444;
}
.sales-kpi-dashboard .skd-ar-stat-card--collected {
  background: #ecfdf5;
  border-color: #bbf7d0;
  color: #15803d;
}
.sales-kpi-dashboard .skd-ar-stat-card--collected .skd-ar-stat-icon {
  background: #22c55e;
}
.sales-kpi-dashboard .skd-ar-stat-icon {
  border-radius: 50%;
  flex-shrink: 0;
  height: 10px;
  width: 10px;
}
.sales-kpi-dashboard .skd-ar-stat-content {
  align-items: center;
  display: flex;
  flex: 1 1;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  min-width: 0;
}
.sales-kpi-dashboard .skd-ar-stat-label,
.sales-kpi-dashboard .skd-ar-stat-value {
  color: inherit;
  font-size: clamp(10px, 2.5vw, 11px);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.35;
  text-transform: none;
}
.sales-kpi-dashboard .skd-ar-stat-label {
  flex: 1 1;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.sales-kpi-dashboard .skd-ar-stat-value {
  flex-shrink: 0;
  max-width: 45%;
  overflow-wrap: anywhere;
  text-align: right;
  word-break: break-word;
}
.sales-kpi-dashboard .skd-donut-stats {
  border-top: 1px solid #f1f5f9;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
  margin-top: 14px;
  padding-top: 14px;
}
.sales-kpi-dashboard .skd-stat-row {
  align-items: center;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
}
.sales-kpi-dashboard .skd-stat-row span:first-child {
  color: var(--skd-muted);
  font-weight: 500;
}
.sales-kpi-dashboard .skd-stat-row span:last-child {
  color: var(--skd-text);
  font-weight: 700;
}
.sales-kpi-dashboard .skd-commented-widget {
  opacity: 0.45;
  pointer-events: none;
  position: relative;
}
.sales-kpi-dashboard .skd-commented-widget::after {
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: var(--skd-card-radius);
  color: var(--skd-muted);
  content: "Coming soon";
  display: flex;
  font-size: 13px;
  font-weight: 600;
  inset: 0;
  justify-content: center;
  position: absolute;
}
@media (max-width: 1199px) {
  .sales-kpi-dashboard {
    padding: 16px 14px 24px;
  }
  .sales-kpi-dashboard .skd-widget-header {
    flex-wrap: wrap;
  }
  .sales-kpi-dashboard .skd-table-toolbar {
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-search-wrap {
    flex: 1 1;
    min-width: 140px;
    width: auto;
  }
  .sales-kpi-dashboard .skd-pmx__stats {
    grid-template-columns: 1fr 1fr;
  }
  .sales-kpi-dashboard .skd-risk-list-item {
    grid-template-columns: minmax(0, 1fr) auto;
    row-gap: 8px;
  }
  .sales-kpi-dashboard .skd-risk-list-item .skd-risk-bar-wrap {
    grid-column: 1/-1;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-widget--risk-panel,
  .sales-kpi-dashboard .skd-widget--client-directory,
  .sales-kpi-dashboard .skd-widget--penetration-panel,
  .sales-kpi-dashboard .skd-widget--scorecard-panel,
  .sales-kpi-dashboard .skd-widget--product-mix,
  .sales-kpi-dashboard .skd-widget--fleet-make-model,
  .sales-kpi-dashboard .skd-widget--fixed-h-lg,
  .sales-kpi-dashboard .skd-widget--fixed-h-md {
    min-height: 300px;
  }
  .sales-kpi-dashboard .skd-period-toggle {
    flex-wrap: wrap;
    justify-content: center;
  }
  .sales-kpi-dashboard .skd-widget-controls {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .sales-kpi-dashboard .skd-penetration-panel-header {
    align-items: center;
    flex-wrap: nowrap;
  }
  .sales-kpi-dashboard .skd-penetration-toggle {
    width: auto;
  }
  .sales-kpi-dashboard .skd-penetration-toggle button {
    flex: 0 0 auto;
  }
}
@media (max-width: 899px) {
  .sales-kpi-dashboard {
    margin: -12px;
    padding: 10px 10px 20px;
  }
  .sales-kpi-dashboard .skd-page-header {
    align-items: stretch;
    flex-direction: column;
  }
  .sales-kpi-dashboard .skd-filter-actions {
    width: 100%;
  }
  .sales-kpi-dashboard .skd-date-filter-wrap,
  .sales-kpi-dashboard .skd-city-filter-wrap,
  .sales-kpi-dashboard .skd-am-filter-wrap,
  .sales-kpi-dashboard .skd-search-btn-wrap {
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-search-btn-wrap button {
    width: 100%;
  }
  .sales-kpi-dashboard .skd-global-search {
    max-width: none;
  }
  .sales-kpi-dashboard .skd-page-title {
    font-size: 16px;
    white-space: normal;
  }
  .sales-kpi-dashboard .skd-mix-stats .skd-mix-stat-box {
    flex: 1 1 100%;
  }
  .sales-kpi-dashboard .skd-mix-stat-value {
    font-size: 18px;
  }
  .sales-kpi-dashboard .skd-ar-stat-content {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 4px;
  }
  .sales-kpi-dashboard .skd-ar-stat-value {
    max-width: 100%;
    text-align: left;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-table-wrap {
    -webkit-overflow-scrolling: touch;
  }
  .sales-kpi-dashboard .skd-table {
    min-width: 520px;
  }
  .sales-kpi-dashboard .skd-scorecard-table {
    min-width: 0;
  }
}
@media (max-width: 599px) {
  .sales-kpi-dashboard .skd-widget {
    padding: 14px 12px;
  }
  .sales-kpi-dashboard .skd-card {
    min-height: 108px;
    padding: 10px;
  }
  .sales-kpi-dashboard .skd-widget-title {
    font-size: 11px;
  }
  .sales-kpi-dashboard .skd-filter-select,
  .sales-kpi-dashboard .skd-search-input {
    font-size: 11px;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-table-toolbar {
    flex-direction: column;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-table-toolbar .skd-filter-select,
  .sales-kpi-dashboard .skd-table-toolbar .skd-search-wrap {
    width: 100%;
  }
  .sales-kpi-dashboard .skd-action-btn,
  .sales-kpi-dashboard .skd-view-btn {
    font-size: 10px;
    padding: 4px 8px;
  }
  .sales-kpi-dashboard .skd-risk-list-item {
    grid-template-columns: 1fr auto;
    padding: 10px 12px;
  }
  .sales-kpi-dashboard .skd-risk-bar-wrap {
    min-width: 0;
  }
}
@media (min-width: 1536px) {
  .sales-kpi-dashboard .skd-ar-stat-label,
  .sales-kpi-dashboard .skd-ar-stat-value {
    font-size: 11px;
  }
}
@container (max-width: 320px) {
  .sales-kpi-dashboard .skd-ar-stat-content {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
  .sales-kpi-dashboard .skd-ar-stat-value {
    max-width: 100%;
    text-align: left;
    width: 100%;
  }
  .sales-kpi-dashboard .skd-ar-stat-card {
    min-height: auto;
    padding: 8px;
  }
}
.sales-kpi-dashboard .skd-throughput-items {
  align-items: center;
  display: flex;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-throughput-item {
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11px;
  gap: 4px;
  white-space: nowrap;
}
.sales-kpi-dashboard .skd-throughput-sep {
  color: inherit;
  flex-shrink: 0;
  opacity: 0.7;
}
.sales-kpi-dashboard .skd-throughput-value {
  font-weight: 600;
}

.sales-kpi-dashboard .skd-week-range {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 220px;
  width: max-content;
}

.sales-kpi-dashboard .skd-week-range-label {
  color: #646a8a;
  display: block;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
}

.sales-kpi-dashboard .skd-week-range-row {
  align-items: center;
  display: flex;
  gap: 6px;
  width: 100%;
}

.sales-kpi-dashboard .skd-week-range-select-wrap {
  background: #fff;
  border: 1px solid #e3e5ee;
  border-radius: 4px;
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  width: 100%;
}

.sales-kpi-dashboard .skd-week-range-select-wrap.is-open,
.sales-kpi-dashboard .skd-week-range-select-wrap:focus-within {
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.sales-kpi-dashboard .skd-week-range-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #161a3a;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  height: 32px;
  padding: 0 4px 0 10px;
  text-align: left;
  width: 100%;
}

.sales-kpi-dashboard .skd-week-range-toggle-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-kpi-dashboard .skd-week-range-chevron-icon {
  fill: #64748b;
  flex-shrink: 0;
  height: 18px;
  pointer-events: none;
  width: 18px;
}

.sales-kpi-dashboard .skd-week-range-select-wrap.is-open .skd-week-range-chevron-icon {
  transform: rotate(180deg);
}

.sales-kpi-dashboard .skd-week-range-menu {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
  left: 0;
  list-style: none;
  margin: 4px 0 0;
  max-height: 160px;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  right: 0;
  top: 100%;
  width: 100%;
  z-index: 30;
}

.sales-kpi-dashboard .skd-week-range-option {
  color: #1e293b;
  cursor: pointer;
  font-size: 13px;
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  white-space: nowrap;
}

.sales-kpi-dashboard .skd-week-range-option:hover {
  background: #f1f5f9;
}

.sales-kpi-dashboard .skd-week-range-option.is-selected {
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SalesDashboard/salesKpiDashboard.scss","webpack://./src/Pages/shared/_dashboardScrollbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,oEAAA;ADEA;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iCAAA;EACA,2BAAA;EAEA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gEAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;AAAF;AAGE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAFJ;AAKE;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;AAHJ;AAME;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAJJ;AAOE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAQE;;EAEE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AANJ;AAQI;;EACE,2BAAA;EACA,wBAAA;EACA,WAAA;AALN;AASE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAPJ;AAUE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EAEA,iBAAA;AATJ;AAYE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAVJ;AAaE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,gBAAA;EACA,mCAAA;EACA,oBAAA;EACA,kCAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,4BAAA;EACA,8CAAA;EACA,WAAA;AAXN;AAaM;EACE,cAAA;AAXR;AAcM;EACE,qBAAA;EACA,8CAAA;AAZR;AAiBE;EACE,cAAA;EACA,0BAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAfJ;AAmBE;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,WAAA;AAjBN;AAoBI;EAdF;IAeI,gDAAA;EAjBJ;AACF;AAmBI;EAlBF;IAmBI,gDAAA;EAhBJ;AACF;AAmBI;EAvBF;IAwBI,QAAA;IACA,kEAAA;EAhBJ;EAkBI;IACE,iBAAA;EAhBN;AACF;AAmBI;EAhCF;IAiCI,QAAA;IACA,kEAAA;EAhBJ;AACF;AAmBE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAjBN;AAmBM;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAjBR;AAuBE;EACE,cAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,cAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,cAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,cAAA;EACA,gBAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,cAAA;EACA,gBAAA;AA1BJ;AA6BE;EACE,mCAAA;EACA,qCAAA;EACA,6BAAA;EACA,2BAAA;EACA,aAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EAAA,YAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,mBAAA;EACA,WAAA;AA3BN;AA6BM;;;;EAIE,gCAAA;AA3BR;AA8BM;EACE,mBAAA;AA5BR;AA+BM;EACE,WAAA;AA7BR;AAgCM;EACE,qCAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AA9BR;AAiCM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AA/BR;AAkCM;;EAEE,gCAAA;AAhCR;AAmCM;EACE,qCAAA;EACA,cAAA;AAjCR;AAoCM;EACE,cAAA;AAlCR;AAqCM;EACE,cAAA;AAnCR;AAsCM;EACE,gCAAA;AApCR;AAwCI;EACE,QAAA;EACA,2CAAA;EACA,iBAAA;EACA,YAAA;AAtCN;AAwCM;EACE,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAtCR;AAyCM;EACE,eAAA;EACA,mBAAA;AAvCR;AA0CM;EACE,mCAAA;EACA,gBAAA;AAxCR;AA2CM;EACE,qBAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;AAzCR;AA4CM;EACE,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;AA1CR;AA6CM;EACE,gBAAA;EACA,aAAA;AA3CR;AA+CI;EACE,mBAAA;EACA,WAAA;AA7CN;AA+CM;;;;EAIE,gCAAA;AA7CR;AAgDM;EACE,WAAA;AA9CR;AAiDM;EACE,qCAAA;AA/CR;AAkDM;EACE,mBAAA;AAhDR;AAoDI;EACE,mBAAA;EACA,WAAA;AAlDN;AAoDM;;;;EAIE,gCAAA;AAlDR;AAqDM;EACE,WAAA;AAnDR;AAsDM;EACE,qCAAA;AApDR;AAuDM;EACE,mBAAA;AArDR;AAyDI;EACE,mBAAA;EACA,cAAA;AAvDN;AAyDM;EACE,cAAA;AAvDR;AA0DM;;;EAGE,cAAA;AAxDR;AA2DM;EACE,cAAA;AAzDR;AA4DM;EACE,kCAAA;AA1DR;AA6DM;EACE,mBAAA;AA3DR;AA+DI;EACE,mBAAA;EACA,cAAA;AA7DN;AA+DM;EACE,cAAA;AA7DR;AAgEM;;;EAGE,cAAA;AA9DR;AAiEM;EACE,cAAA;AA/DR;AAkEM;EACE,oCAAA;AAhER;AAmEM;EACE,oDAAA;AAjER;AAqEI;EACE,mBAAA;EACA,cAAA;AAnEN;AAqEM;EACE,cAAA;AAnER;AAsEM;;;EAGE,cAAA;AApER;AAuEM;EACE,cAAA;AArER;AAwEM;EACE,mCAAA;AAtER;AAyEM;EACE,mBAAA;AAvER;AA2EI;EACE,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAzEN;AA6EE;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AA5EJ;AA+EE;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA7EJ;AAgFE;EACE,0BAAA;AA9EJ;AAiFE;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AA/EJ;AAkFE;EACE,qBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,QAAA;EACA,YAAA;AAhFJ;AAmFE;EACE,sBAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjFJ;AAoFE;EACE,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlFJ;AAqFE;EACE,uBAAA;EACA,mCAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnFJ;AAqFI;EACE,4BAAA;EACA,sBAAA;AAnFN;AAuFE;EACE,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AArFJ;AAuFI;EACE,gBAAA;AArFN;AA4FM;;EACE,aAAA;EACA,WAAA;AAzFR;AA8FE;EACE,qBAAA;EACA,oBAAA;EACA,YAAA;AA5FJ;AA+FE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7FJ;AAgGE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AA/FJ;AAkGE;EACE,qBAAA;EACA,oBAAA;EAAA,eAAA;EACA,aAAA;EACA,oDAAA;EACA,YAAA;EACA,WAAA;AAhGJ;AAmGE;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAjGJ;AAoGE;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EAAA,kCAAA;EACA,mBAAA;AAlGJ;AAqGE;EACE,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnGJ;AAsGE;EACE,qBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AApGJ;AAuGE;EACE,gBAAA;EACA,aAAA;AArGJ;AAwGE;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtGJ;AAyGE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAvGJ;AA0GE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AAxGJ;AA2GE;EACE,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzGJ;AA4GE;EACE,cAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AA1GJ;AA6GE;EACE,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AA3GJ;AA8GE;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,2BAAA;AA5GJ;AA+GE;EACE,cAAA;AA7GJ;AAgHE;EACE,cAAA;AA9GJ;AAiHE;EACE,cAAA;AA/GJ;AAkHE;EACE,cAAA;AAhHJ;AAmHE;;;;;;EAME,yBAAA;AAjHJ;AAsHI;;;;;;EAGE,gCAAA;AAjHN;AAsHE;EACE,gBAAA;EACA,mCAAA;EACA,qCAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AApHJ;AAsHI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AApHN;AAsHM;EARF;IASI,aAAA;IACA,iBAAA;IACA,iBAAA;EAnHN;AACF;AAsHI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AApHN;AAsHM;EARF;IASI,aAAA;IACA,iBAAA;IACA,iBAAA;EAnHN;AACF;AAsHI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AApHN;AAsHM;EARF;IASI,aAAA;IACA,iBAAA;IACA,iBAAA;EAnHN;AACF;AAsHI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AArHN;AAuHM;EAzBF;IA0BI,aAAA;IACA,iBAAA;IACA,iBAAA;EApHN;AACF;AAuHI;EAEE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAtHN;AAwHM;EATF;IAUI,aAAA;IACA,iBAAA;IACA,iBAAA;EArHN;AACF;AAuHM;EACE,cAAA;EACA,mBAAA;AArHR;AA0HM;EACE,mBAAA;EACA,mBAAA;AAxHR;AA0HQ;EACE,gBAAA;AAxHV;AA8HM;EACE,mBAAA;EACA,mBAAA;AA5HR;AA8HQ;EACE,gBAAA;AA5HV;AAiII;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAhIN;AAkIM;EAnBF;IAoBI,aAAA;IACA,iBAAA;IACA,iBAAA;EA/HN;AACF;AAkII;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAjIN;AAmIM;EAnBF;IAoBI,aAAA;IACA,iBAAA;IACA,iBAAA;EAhIN;AACF;AAoIE;;EAEE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAlIJ;AAqIE;EACE,8BAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAnIJ;AAqII;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;AAnIN;AAqIM;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnIR;AAwIE;EACE,cAAA;EACA,YAAA;AAtIJ;AAyIE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAvIJ;AA0IE;EACE,cAAA;AAxIJ;AA2IE;EACE,8BAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAzIJ;AA2II;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;AAzIN;AA2IM;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzIR;AA6II;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AA3IN;AA+IE;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;AA7IJ;AAgJE;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,0EACE;AA/IN;AAmJI;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;AAjJN;AAmJM;EACE,cAAA;EACA,eAAA;AAjJR;AAqJI;EACE,oCAAA;EACA,cAAA;AAnJN;AAsJI;EACE,gBAAA;EACA,+EACE;AArJR;AAyJI;EACE,cAAA;AAvJN;AA0JI;EACE,cAAA;AAxJN;AA4JE;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AA1JJ;AA6JE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA3JJ;AA8JE;EACE,eAAA;EACA,gBAAA;AA5JJ;AA8JI;EACE,cAAA;AA5JN;AA+JI;EACE,cAAA;AA7JN;AAgKI;EACE,cAAA;AA9JN;AAkKE;EACE,eAAA;EACA,gBAAA;AAhKJ;AAkKI;EACE,cAAA;AAhKN;AAmKI;EACE,cAAA;AAjKN;AAoKI;EACE,cAAA;AAlKN;AAsKE;EACE,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AApKJ;AAuKE;EACE,oBAAA;EACA,cAAA;EACA,YAAA;EACA,2BAAA;AArKJ;AAuKI;EACE,oDAAA;AArKN;AAwKI;EACE,oDAAA;AAtKN;AAyKI;EACE,oDAAA;AAvKN;AA2KE;EACE,YAAA;EACA,WAAA;AAzKJ;AA2KI;;EAEE,eAAA;EACA,gBAAA;EACA,sBAAA;AAzKN;AA4KI;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AA1KN;AA6KI;;EAEE,cAAA;EACA,gBAAA;AA3KN;AA8KI;;EAEE,cAAA;EACA,gBAAA;AA5KN;AA+KI;;EAEE,cAAA;EACA,gBAAA;AA7KN;AAgLI;EACE,cAAA;AA9KN;AAiLI;EACE,cAAA;AA/KN;AAkLI;EACE,cAAA;AAhLN;AAmLI;;;;EAIE,kBAAA;AAjLN;AAoLI;;EAEE,iBAAA;AAlLN;AAqLI;EACE,6BAAA;AAnLN;AAuLE;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArLJ;AAwLE;EACE,mBAAA;AAtLJ;AAwLI;EACE,cAAA;AAtLN;AAyLI;EACE,cAAA;AAvLN;AA0LI;EACE,cAAA;AAxLN;AA4LE;EACE,8BAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AA1LJ;AA4LI;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA1LN;AA4LM;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1LR;AA+LE;EACE,cAAA;EACA,YAAA;AA7LJ;AAgME;EACE,cAAA;EACA,mBAAA;AA9LJ;AAiME;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;AA/LJ;AAkME;EACE,sBAAA;EAAA,sCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAhMJ;AAmME;EACE,6BAAA;EAAA,8CAAA;EACA,mCAAA;EAAA,oDAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EAAA,QAAA;EACA,gDAAA;EACA,gBAAA;AAjMJ;AAmMI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;AAjMN;AAoMI;EACE,uBAAA;EAAA,yCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAlMN;AAqMI;;EAEE,sBAAA;EAAA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAnMN;AAsMI;EACE,wBAAA;AApMN;AAuMI;EACE,qBAAA;AArMN;AAyME;EACE,aAAA;EACA,cAAA;EACA,QAAA;AAvMJ;AA0ME;EACE,mBAAA;EACA,mCAAA;EAAA,oDAAA;EACA,kBAAA;EACA,uBAAA;EAAA,yCAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAxMJ;AA0MI;EACE,6BAAA;AAxMN;AA2MI;EACE,uBAAA;EACA,SAAA;EACA,sBAAA;EAAA,sCAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAzMN;AA2MM;EACE,uBAAA;EAAA,yCAAA;AAzMR;AA8ME;EACE,cAAA;EACA,UAAA;EACA,0BAAA;AA5MJ;AA+ME;EACE,gBAAA;EACA,mCAAA;EAAA,oDAAA;EACA,kBAAA;EACA,sBAAA;EAAA,uCAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA7MJ;AAgNE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AA9MJ;AAiNE;EACE,gCAAA;EAAA,kDAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EAAA,aAAA;EACA,0CAAA;EACA,iBAAA;AA/MJ;AAiNI;EACE,mBAAA;EAAA,qCAAA;AA/MN;AAmNE;EACE,sBAAA;EAAA,sCAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;AAjNJ;AAoNE;EACE,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAlNJ;AAoNI;EACE,qBAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;AAlNN;AAsNE;EACE,mBAAA;EACA,uBAAA;EAAA,yCAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AApNJ;AAuNE;EACE,sBAAA;EACA,gBAAA;AArNJ;AAwNE;EACE,uBAAA;EACA,gBAAA;AAtNJ;AAwNI;EACE,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAtNN;AA0NE;EACE,4BAAA;EAAA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;AAxNJ;AA2NE;EACE,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAzNJ;AA2NI;EACE,wBAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;AAzNN;AA6NE;EACE,mBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA3NJ;AA6NI;EACE,oDAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AA3NN;AA+NE;EACE,uBAAA;EAAA,yCAAA;EACA,iBAAA;EACA,kBAAA;AA7NJ;AAgOE;EACE,uBAAA;EAAA,yCAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AA9NJ;AAiOE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AA/NJ;AAkOE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EC9jDF,qBAAA;EACA,gCAAA;AD+1CF;AC71CE;EACE,WD2jDwB;EC1jDxB,UD0jDwB;AA3N5B;AC51CE;EACE,mBAAA;EACA,mBAAA;AD81CJ;AC31CE;EACE,mBAAA;EACA,mBAAA;AD61CJ;AC11CE;EACE,mBAAA;AD41CJ;ACz1CE;EACE,uBAAA;AD21CJ;AAgNE;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AA9MJ;AAiNE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;AA/MJ;AAiNI;EACE,cAAA;AA/MN;AAmNE;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AAjNJ;AAoNE;EACE,uBAAA;EACA,0BAAA;AAlNJ;AAqNE;EACE,uBAAA;EACA,eAAA;EACA,eAAA;AAnNJ;AAsNE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AApNJ;AAuNE;EACE,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;AArNJ;AAuNI;EACE,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AArNN;AAuNM;EACE,mBAAA;EACA,4CAAA;EACA,WAAA;AArNR;AAwNM;EACE,sBAAA;AAtNR;AA2NE;EACE,mBAAA;EACA,gBAAA;EACA,mCAAA;EACA,oBAAA;EACA,kCAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AAzNJ;AA4NE;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,WAAA;EACA,UAAA;AA1NJ;AA6NE;EACE;IAEE,UAAA;EA5NJ;EA+NE;IACE,aAAA;EA7NJ;AACF;AAgOE;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AA9NJ;AAkOE;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;EACA,gDAAA;EACA,kBAAA;AAhOJ;AAmOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;AAjOJ;AAoOE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlOJ;AAqOE;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnOJ;AAsOE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AApOJ;AAuOE;EACE,eAAA;EACA,YAAA;AArOJ;AAwOE;EACE,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AAtOJ;AAwOI;EACE,oDAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAtON;AA0OE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAxOJ;AA0OI;EACE,mBAAA;EACA,qBAAA;AAxON;AA4OE;EACE,mBAAA;EACA,qDAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AA1OJ;AA4OI;EACE,wBAAA;AA1ON;AA6OI;EACE,mBAAA;EACA,aAAA;AA3ON;AAgPE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;AA9OJ;AAiPE;EACE,sBAAA;EAAA,sCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;AA/OJ;AAkPE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EC10DF,qBAAA;EACA,gCAAA;AD2lDF;ACzlDE;EACE,WDu0DwB;ECt0DxB,UDs0DwB;AA3O5B;ACxlDE;EACE,mBAAA;EACA,mBAAA;AD0lDJ;ACvlDE;EACE,mBAAA;EACA,mBAAA;ADylDJ;ACtlDE;EACE,mBAAA;ADwlDJ;ACrlDE;EACE,uBAAA;ADulDJ;AAgOE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;AA9NJ;AAgOI;EACE,uCAAA;EAAA,wDAAA;EACA,iBAAA;AA9NN;AAkOE;EACE,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAhOJ;AAmOE;;EAEE,mBAAA;EAAA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAjOJ;AAmOI;;EACE,cAAA;EACA,YAAA;EACA,YAAA;AAhON;AAoOE;EACE,YAAA;AAlOJ;AAoOI;EACE,cAAA;AAlON;AAsOE;EACE,YAAA;AApOJ;AAuOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AArOJ;AAuOI;EACE,mBAAA;EACA,sBAAA;EAAA,sCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EAAA,QAAA;EACA,+CAAA;AArON;AAwOI;EACE,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,mBAAA;AAtON;AA0OE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxOJ;AA2OE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AAzOJ;AA4OE;EACE,qBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AA1OJ;AA4OI;EACE,cAAA;EAAA,+BAAA;EACA,eAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,cAAA;AA1ON;AA6OI;EACE,uBAAA;EAAA,yCAAA;EACA,iBAAA;EACA,iBAAA;AA3ON;AA+OE;EACE,aAAA;EACA,aAAA;EAAA,QAAA;EACA,8BAAA;AA7OJ;AAgPE;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA9OJ;AAgPI;EACE,sBAAA;EAAA,uCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AA9ON;AAiPI;EACE,cAAA;EACA,eAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA/ON;AAkPI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAhPN;AAmPI;EACE,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;AAjPN;AAmPM;EACE,eAAA;EACA,aAAA;AAjPR;AAqPI;EACE,mBAAA;EACA,qBAAA;AAnPN;AAqPM;EACE,cAAA;EAAA,+BAAA;AAnPR;AAuPI;EACE,mBAAA;EACA,qBAAA;AArPN;AAuPM;EACE,cAAA;AArPR;AA2PE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;AAzPJ;AA4PE;EACE,sBAAA;EAAA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AA1PJ;AA6PE;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AA3PJ;AA6PI;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AA3PN;AA6PM;EAEE,gBAAA;EACA,4CAAA;EACA,cAAA;EAAA,+BAAA;AA5PR;AAiQE;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AA/PJ;AAkQE;EACE,sBAAA;EAAA,sCAAA;EACA,eAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,cAAA;AAhQJ;AAkQI;EACE,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhQN;AAoQE;EACE,uBAAA;EAAA,yCAAA;EACA,iBAAA;AAlQJ;AAoQI;EACE,sBAAA;EAAA,uCAAA;EACA,gBAAA;AAlQN;AAsQE;EACE,mBAAA;EAAA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AApQJ;AAsQI;EACE,aAAA;AApQN;AAuQI;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;AArQN;AAuQM;EACE,UAAA;AArQR;AA0QE;EACE,sBAAA;EAAA,uCAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAxQJ;AA0QI;EACE,mBAAA;EACA,oBAAA;EACA,QAAA;AAxQN;AA2QI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;AAzQN;AA4QI;EACE,6BAAA;EAAA,kCAAA;EACA,gBAAA;AA1QN;AA8QE;EACE,mBAAA;EACA,mCAAA;EAAA,oDAAA;EACA,kBAAA;EACA,uBAAA;EAAA,yCAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AA5QJ;AA8QI;EACE,qBAAA;EAAA,sCAAA;AA5QN;AA+QI;EACE,uBAAA;EACA,SAAA;EACA,sBAAA;EAAA,sCAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;AA7QN;AA+QM;EACE,uBAAA;EAAA,yCAAA;AA7QR;AAkRE;EACE,cAAA;EACA,UAAA;EACA,0BAAA;AAhRJ;AAmRE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AAjRJ;AAoRE;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EAAA,aAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAlRJ;AAoRI;EACE,mBAAA;EAAA,qCAAA;AAlRN;AAqRI;EACE,eAAA;EACA,0CAAA;AAnRN;AAqRM;EACE,iBAAA;AAnRR;AAuRI;EACE,cAAA;EAAA,+BAAA;EACA,wBAAA;AArRN;AAyRE;EACE,uBAAA;EAAA,yCAAA;EACA,0BAAA;EACA,2BAAA;AAvRJ;AA0RE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxRJ;AA0RI;EACE,uBAAA;EAAA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAxRN;AA4RE;EACE,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,mBAAA;AA1RJ;AA4RI;EACE,uBAAA;EAAA,yCAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA1RN;AA8RE;EACE,mBAAA;EAAA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AA5RJ;AA8RI;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AA5RN;AAgSE;EACE,wCAAA;EAAA,yDAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;AA9RJ;AAgSI;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EAAA,aAAA;EACA,0CAAA;EACA,gBAAA;AA9RN;AAiSI;EACE,gBAAA;AA/RN;AAkSI;EACE,iBAAA;EACA,WAAA;AAhSN;AAkSM;EACE,YAAA;AAhSR;AAqSE;EACE,uBAAA;EAAA,yCAAA;EACA,iBAAA;EACA,kBAAA;AAnSJ;AAsSE;EACE,mBAAA;EACA,uCAAA;EAAA,wDAAA;EACA,uBAAA;EAAA,yCAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;AApSJ;AAsSI;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EAAA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApSN;AAySE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAvSJ;AA0SE;EACE,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAxSJ;AA2SE;EACE,kBAAA;EACA,YAAA;AAzSJ;AA4SE;EACE,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AA1SJ;AA4SI;EACE,cAAA;AA1SN;AA6SI;EACE,qBAAA;EACA,6CAAA;AA3SN;AA+SE;EACE,cAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AA7SJ;AAgTE;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,iCAAA;ECj4EF,qBAAA;EACA,gCAAA;ADolEF;ACllEE;EACE,WD83EwB;EC73ExB,UD63EwB;AAzS5B;ACjlEE;EACE,mBAAA;EACA,mBAAA;ADmlEJ;AChlEE;EACE,mBAAA;EACA,mBAAA;ADklEJ;AC/kEE;EACE,mBAAA;ADilEJ;AC9kEE;EACE,uBAAA;ADglEJ;AA8RE;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AA5RJ;AA8RI;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;AA5RN;AA8RM;EACE,aAAA;AA5RR;AA+RM;EACE,0BAAA;EACA,0BAAA;AA7RR;AAgSM;EACE,cAAA;AA9RR;AAiSM;EACE,cAAA;AA/RR;AAkSM;EACE,cAAA;AAhSR;AAmSM;EACE,cAAA;AAjSR;AAqSI;EACE,eAAA;EACA,cAAA;AAnSN;AAsSI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AApSN;AAuSI;;EAEE,eAAA;EACA,kBAAA;EACA,gBAAA;AArSN;AAwSI;EACE,mBAAA;EACA,0CAAA;EACA,qCAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAtSN;AAySI;EACE,gCAAA;EACA,sBAAA;AAvSN;AA0SI;;EAEE,cAAA;EACA,gBAAA;AAxSN;AA2SI;;EAEE,cAAA;EACA,gBAAA;AAzSN;AA4SI;;EAEE,cAAA;EACA,gBAAA;AA1SN;AA6SI;;EAEE,cAAA;EACA,gBAAA;EACA,YAAA;AA3SN;AA8SI;;EAEE,cAAA;EACA,gBAAA;AA5SN;AA+SI;;EAEE,cAAA;EACA,gBAAA;AA7SN;AAgTI;EACE,mBAAA;AA9SN;AAiTI;EACE,mBAAA;AA/SN;AAmTE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAjTJ;AAmTI;EACE,mBAAA;AAjTN;AAsTE;EACE,2BAAA;EACA,aAAA;EACA,aAAA;EAAA,QAAA;EACA,4CAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AApTJ;AAsTI;EACE;IACE,aAAA;IACA,iBAAA;IACA,iBAAA;EApTN;AACF;AAwTE;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAtTJ;AAyTE;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAvTJ;AAyTI;;;;EAIE,0BAAA;AAvTN;AA0TI;;EAEE,wBAAA;EACA,sBAAA;AAxTN;AA4TE;EACE,aAAA;AA1TJ;AA6TE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AA3TJ;AA8TE;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AA5TJ;AA8TI;EACE,6CAAA;AA5TN;AA+TI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA7TN;AA+TM;EACE,mBAAA;AA7TR;AAiUI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA/TN;AAiUM;EACE,mBAAA;AA/TR;AAmUI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAjUN;AAmUM;EACE,mBAAA;AAjUR;AAsUE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AApUJ;AAuUE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;EACA,YAAA;AArUJ;AAwUE;;EAEE,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAtUJ;AAyUE;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;AAvUJ;AA0UE;EACE,cAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AAxUJ;AA2UE;EACE,6BAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;EACA,iBAAA;AAzUJ;AA4UE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AA1UJ;AA4UI;EACE,uBAAA;EACA,gBAAA;AA1UN;AA6UI;EACE,sBAAA;EACA,gBAAA;AA3UN;AA+UE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;AA7UJ;AA+UI;EACE,mBAAA;EACA,oCAAA;EACA,qCAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AA7UN;AAkVE;EAhuFF;IAiuFI,uBAAA;EA/UF;EAiVE;IACE,eAAA;EA/UJ;EAkVE;IACE,eAAA;IACA,yBAAA;IACA,WAAA;EAhVJ;EAmVE;IACE,SAAA;IACA,gBAAA;IACA,WAAA;EAjVJ;EAoVE;IACE,8BAAA;EAlVJ;EAqVE;IACE,0CAAA;IACA,YAAA;EAnVJ;EAqVI;IACE,iBAAA;IACA,WAAA;EAnVN;EAuVE;;;;;;;;IAQE,iBAAA;EArVJ;EAwVE;IACE,eAAA;IACA,uBAAA;EAtVJ;EAyVE;IACE,eAAA;IACA,yBAAA;EAvVJ;EA0VE;IACE,mBAAA;IACA,iBAAA;EAxVJ;EA2VE;IACE,WAAA;EAzVJ;EA2VI;IACE,cAAA;EAzVN;AACF;AA6VE;EApyFF;IAqyFI,aAAA;IACA,uBAAA;EA1VF;EA4VE;IACE,oBAAA;IACA,sBAAA;EA1VJ;EA6VE;IACE,WAAA;EA3VJ;EA8VE;;;;IAIE,cAAA;IACA,YAAA;IACA,WAAA;EA5VJ;EA+VE;IACE,WAAA;EA7VJ;EAgWE;IACE,eAAA;EA9VJ;EAiWE;IACE,eAAA;IACA,mBAAA;EA/VJ;EAkWE;IACE,cAAA;EAhWJ;EAmWE;IACE,eAAA;EAjWJ;EAoWE;IACE,uBAAA;IACA,eAAA;IACA,QAAA;EAlWJ;EAqWE;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EAnWJ;EAsWE;IACE,iCAAA;EApWJ;EAuWE;IACE,gBAAA;EArWJ;EAwWE;IACE,YAAA;EAtWJ;AACF;AAyWE;EACE;IACE,kBAAA;EAvWJ;EA0WE;IACE,iBAAA;IACA,aAAA;EAxWJ;EA2WE;IACE,eAAA;EAzWJ;EA4WE;;IAEE,eAAA;IACA,WAAA;EA1WJ;EA6WE;IACE,sBAAA;IACA,WAAA;EA3WJ;EA6WI;;IAEE,WAAA;EA3WN;EA+WE;;IAEE,eAAA;IACA,gBAAA;EA7WJ;EAgXE;IACE,+BAAA;IACA,kBAAA;EA9WJ;EAiXE;IACE,YAAA;EA/WJ;AACF;AAkXE;EACE;;IAEE,eAAA;EAhXJ;AACF;AAmXE;EACE;IACE,uBAAA;IACA,sBAAA;IACA,QAAA;EAjXJ;EAoXE;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EAlXJ;EAqXE;IACE,gBAAA;IACA,YAAA;EAnXJ;AACF;AAuXE;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AArXJ;AAwXE;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAtXJ;AAyXE;EACE,cAAA;EACA,cAAA;EACA,YAAA;AAvXJ;AA0XE;EACE,gBAAA;AAxXJ;;AA4XA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AAzXF;;AA4XA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAzXF;;AA4XA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AAzXF;;AA4XA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAzXF;;AA4XA;;EAEE,qBAAA;EACA,8CAAA;AAzXF;;AA4XA;EACE,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AAzXF;;AA4XA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzXF;;AA4XA;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AAzXF;;AA4XA;EACE,yBAAA;AAzXF;;AA4XA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAzXF;;AA4XA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAzXF;;AA4XA;EACE,mBAAA;AAzXF;;AA4XA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAzXF","sourcesContent":["@import \"../shared/dashboardScrollbar\";\n\n.sales-kpi-dashboard {\n  --skd-bg: #f3f4f8;\n  --skd-card-radius: 10px;\n  --skd-shadow: none;\n  --skd-shadow-soft: none;\n  --skd-text: #161a3a;\n  --skd-muted: #646a8a;\n  --skd-border: #e3e5ee;\n  --skd-navy: #1b1f4b;\n  --skd-scroll-thumb: #9aa8d6;\n  --skd-scroll-thumb-hover: #2f5bea;\n  --skd-scroll-track: #eef1f8;\n\n  background: var(--skd-bg);\n  box-sizing: border-box;\n  color: var(--skd-text);\n  display: flex;\n  flex-direction: column;\n  font-family: \"Open Sans\", \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 13.5px;\n  gap: 12px;\n  line-height: 1.4;\n  margin: -20px;\n  min-height: calc(100vh - 64px);\n  padding: 12px 12px 24px;\n  width: auto;\n\n  // ── Page header (matches ExDashboard ContractTypeFilterBar) ──\n  .skd-page-header {\n    align-items: center;\n    display: flex;\n    gap: 12px;\n    justify-content: space-between;\n    margin-bottom: 0;\n  }\n\n  .skd-date-filter-bar {\n    background: #fff;\n    border: 1px solid #e3e5ee;\n    border-radius: 10px;\n    box-shadow: none;\n    flex-wrap: wrap;\n    margin-bottom: 0;\n    overflow: visible;\n    padding: 10px 14px;\n    position: relative;\n    z-index: 3;\n  }\n\n  .skd-filter-actions {\n    align-items: flex-end;\n    display: flex;\n    flex: 1 1 auto;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: flex-end;\n    min-width: 0;\n  }\n\n  .skd-week-filter-wrap {\n    flex: 0 0 auto;\n    max-width: 100%;\n    overflow: visible;\n    position: relative;\n    width: max-content;\n    z-index: 2;\n  }\n\n  .skd-date-filter-wrap {\n    flex: 0 1 220px;\n    max-width: 100%;\n    min-width: 180px;\n  }\n\n  .skd-city-filter-wrap,\n  .skd-am-filter-wrap {\n    display: flex;\n    flex: 0 1 220px;\n    flex-direction: column;\n    gap: 3px;\n    max-width: 100%;\n    min-width: 180px;\n\n    > div {\n      margin-bottom: 0 !important;\n      margin-top: 0 !important;\n      width: 100%;\n    }\n  }\n\n  .skd-filter-field-label {\n    color: #646a8a;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  .skd-search-btn-wrap {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    // Align with control row (skip label height like Ex search button)\n    padding-top: 15px;\n  }\n\n  .skd-page-title {\n    color: #1b1f4b;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    line-height: 1.25;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  .skd-global-search {\n    flex: 1;\n    max-width: 520px;\n    position: relative;\n\n    input {\n      background: #fff;\n      border: 1px solid var(--skd-border);\n      border-radius: 999px;\n      box-shadow: var(--skd-shadow-soft);\n      color: var(--skd-text);\n      font-size: 13px;\n      outline: none;\n      padding: 11px 16px 11px 40px;\n      transition: border-color 0.2s, box-shadow 0.2s;\n      width: 100%;\n\n      &::placeholder {\n        color: #94a3b8;\n      }\n\n      &:focus {\n        border-color: #93c5fd;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n      }\n    }\n  }\n\n  .skd-global-search-icon {\n    color: #94a3b8;\n    font-size: 18px !important;\n    left: 14px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  // ── KPI cards ────────────────────────────────────────────\n  .skd-kpi-grid {\n    align-items: stretch;\n    display: grid;\n    gap: 10px;\n    grid-auto-rows: 1fr;\n    grid-template-columns: 1fr;\n    margin-bottom: 14px;\n    width: 100%;\n\n    > * {\n      min-width: 0;\n      width: 100%;\n    }\n\n    @media (min-width: 600px) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    @media (min-width: 900px) and (max-width: 1023px) {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    // Laptop+: always one row (6 cards)\n    @media (min-width: 1024px) {\n      gap: 6px;\n      grid-template-columns: minmax(0, 1.45fr) repeat(5, minmax(0, 1fr));\n\n      .skd-card--wide {\n        grid-column: auto;\n      }\n    }\n\n    @media (min-width: 1440px) {\n      gap: 8px;\n      grid-template-columns: minmax(0, 1.75fr) repeat(5, minmax(0, 1fr));\n    }\n  }\n\n  .skd-section-row {\n    margin-bottom: 0;\n    max-width: 100%;\n    min-width: 0;\n    width: 100%;\n\n    > .MuiGrid-item {\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      min-width: 0;\n\n      > * {\n        flex: 1;\n        max-width: 100%;\n        min-width: 0;\n        width: 100%;\n      }\n    }\n  }\n\n  // Shared metric column colors\n  .skd-col-fleet {\n    color: #2563eb;\n    font-weight: 700;\n  }\n\n  .skd-col-throughput {\n    color: #16a34a;\n    font-weight: 700;\n  }\n\n  .skd-col-outstanding {\n    color: #d97706;\n    font-weight: 700;\n  }\n\n  .skd-col-overdue {\n    color: #dc2626;\n    font-weight: 700;\n  }\n\n  .skd-col-accounts {\n    color: #16a34a;\n    font-weight: 700;\n  }\n\n  .skd-col-vehicles {\n    color: #0891b2;\n    font-weight: 700;\n  }\n\n  .skd-card {\n    border: 1px solid var(--skd-border);\n    border-radius: var(--skd-card-radius);\n    box-shadow: var(--skd-shadow);\n    container-type: inline-size;\n    display: grid;\n    grid-template-rows: 14px 26px 16px 1fr auto;\n    height: 100%;\n    min-height: 118px;\n    overflow: hidden;\n    padding: 12px 14px 10px;\n    row-gap: 4px;\n    position: relative;\n\n    &--revenue {\n      background: #1d3461;\n      color: #fff;\n\n      .skd-card-label,\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: rgba(255, 255, 255, 0.74);\n      }\n\n      .skd-card-label {\n        padding-right: 68px;\n      }\n\n      .skd-card-value {\n        color: #fff;\n      }\n\n      .skd-progress-track {\n        background: rgba(255, 255, 255, 0.22);\n        height: 5px;\n        overflow: visible;\n        position: relative;\n      }\n\n      .skd-progress-fill {\n        background: #fff;\n        border-radius: 9px;\n        overflow: hidden;\n      }\n\n      .skd-rev-vs,\n      .skd-card-mom-prev {\n        color: rgba(255, 255, 255, 0.55);\n      }\n\n      .skd-rev-badge {\n        background: rgba(255, 255, 255, 0.74);\n        color: #1d3461;\n      }\n\n      .skd-mom-badge.is-good {\n        color: #7ff0b0;\n      }\n\n      .skd-mom-badge.is-bad {\n        color: #ff9b9b;\n      }\n\n      .skd-mom-badge.is-flat {\n        color: rgba(255, 255, 255, 0.74);\n      }\n    }\n\n    &--revenue-detail {\n      gap: 4px;\n      grid-template-rows: auto auto auto 1fr auto;\n      min-height: 140px;\n      row-gap: 4px;\n\n      .skd-card-sub {\n        color: rgba(255, 255, 255, 0.74);\n        font-size: 11.5px;\n        line-height: 15px;\n        overflow: visible;\n        text-overflow: unset;\n        white-space: normal;\n      }\n\n      .skd-card-footer {\n        font-size: 11px;\n        white-space: nowrap;\n      }\n\n      .skd-card-value {\n        font-size: clamp(18px, 12cqi, 23px);\n        font-weight: 900;\n      }\n\n      .skd-card-value-row {\n        align-items: baseline;\n        flex-wrap: nowrap;\n        gap: 8px;\n        width: 100%;\n      }\n\n      .skd-card-after-value {\n        align-items: baseline;\n        display: inline-flex;\n        flex: 1 1 auto;\n        gap: 8px;\n        min-width: 0;\n      }\n\n      .skd-card-bottom {\n        margin-top: auto;\n        min-height: 0;\n      }\n    }\n\n    &--throughput {\n      background: #0f69a7;\n      color: #fff;\n\n      .skd-card-label,\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: rgba(255, 255, 255, 0.85);\n      }\n\n      .skd-card-value {\n        color: #fff;\n      }\n\n      .skd-progress-track {\n        background: rgba(255, 255, 255, 0.22);\n      }\n\n      .skd-progress-fill {\n        background: #86efac;\n      }\n    }\n\n    &--fleet {\n      background: #15b9bb;\n      color: #fff;\n\n      .skd-card-label,\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: rgba(255, 255, 255, 0.85);\n      }\n\n      .skd-card-value {\n        color: #fff;\n      }\n\n      .skd-progress-track {\n        background: rgba(255, 255, 255, 0.22);\n      }\n\n      .skd-progress-fill {\n        background: #ecfccb;\n      }\n    }\n\n    &--pms {\n      background: #a1d0a2;\n      color: #1e3a2f;\n\n      .skd-card-label {\n        color: #2d4a3e;\n      }\n\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: #2d4a3e;\n      }\n\n      .skd-card-value {\n        color: #1a3328;\n      }\n\n      .skd-progress-track {\n        background: rgba(30, 58, 47, 0.18);\n      }\n\n      .skd-progress-fill {\n        background: #1a3328;\n      }\n    }\n\n    &--risk {\n      background: #fbe9d5;\n      color: #7c2d12;\n\n      .skd-card-label {\n        color: #9a3412;\n      }\n\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: #9a3412;\n      }\n\n      .skd-card-value {\n        color: #c2410c;\n      }\n\n      .skd-progress-track {\n        background: rgba(247, 175, 93, 0.45);\n      }\n\n      .skd-progress-fill {\n        background: linear-gradient(90deg, #f7af5d, #ef4444);\n      }\n    }\n\n    &--outstanding {\n      background: #f7af5d;\n      color: #78350f;\n\n      .skd-card-label {\n        color: #92400e;\n      }\n\n      .skd-card-sub,\n      .skd-card-footer,\n      .skd-card-unit {\n        color: #92400e;\n      }\n\n      .skd-card-value {\n        color: #7c2d12;\n      }\n\n      .skd-progress-track {\n        background: rgba(120, 53, 15, 0.18);\n      }\n\n      .skd-progress-fill {\n        background: #7c2d12;\n      }\n    }\n\n    &--skeleton {\n      background: #fff;\n      border: 1px solid var(--skd-border);\n      display: flex;\n      flex-direction: column;\n      grid-template-rows: none;\n    }\n  }\n\n  .skd-card-label {\n    align-items: center;\n    color: var(--skd-muted);\n    display: flex;\n    font-size: clamp(8px, 5.2cqi, 10px);\n    font-weight: 700;\n    gap: 4px;\n    letter-spacing: 0.06em;\n    line-height: 14px;\n    margin: 0;\n    min-width: 0;\n    overflow: hidden;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  .skd-card-label-text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .skd-card-info {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    line-height: 0;\n    position: relative;\n    z-index: 3;\n  }\n\n  .skd-card-info-icon {\n    font-size: 13px !important;\n  }\n\n  .skd-card-main {\n    align-items: center;\n    display: flex;\n    min-height: 26px;\n    min-width: 0;\n  }\n\n  .skd-card-value-row {\n    align-items: baseline;\n    display: flex;\n    flex: 1;\n    flex-wrap: nowrap;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .skd-card-value {\n    color: var(--skd-text);\n    flex: 0 0 auto;\n    font-size: clamp(13px, 10.5cqi, 22px);\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 1.1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-card-unit {\n    flex: 0 1 auto;\n    font-size: clamp(8px, 5.6cqi, 11px);\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 1.2;\n    min-width: 0;\n    opacity: 0.82;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-card-sub {\n    color: var(--skd-muted);\n    font-size: clamp(8px, 5.4cqi, 11px);\n    line-height: 16px;\n    margin: 0;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    svg {\n      font-size: 0.95em !important;\n      vertical-align: middle;\n    }\n  }\n\n  .skd-card-meta {\n    align-items: center;\n    display: inline-flex;\n    gap: 4px;\n    max-width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n\n    strong {\n      font-weight: 700;\n    }\n  }\n\n  .skd-card--wide {\n    .skd-card-sub,\n    .skd-card-footer {\n      .skd-card-meta {\n        display: flex;\n        width: 100%;\n      }\n    }\n  }\n\n  .skd-card-after-value {\n    align-items: baseline;\n    display: inline-flex;\n    min-width: 0;\n  }\n\n  .skd-card-mom-prev {\n    font-size: 11px;\n    font-weight: 500;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-mom-badge {\n    flex: 0 0 auto;\n    font-size: 11.5px;\n    font-weight: 700;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  .skd-rev-split {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .skd-rev-split-row {\n    align-items: baseline;\n    column-gap: 7px;\n    display: grid;\n    grid-template-columns: auto auto minmax(0, 1fr) auto;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .skd-rev-badge {\n    align-self: center;\n    border-radius: 3px;\n    font-size: 9px;\n    font-weight: 900;\n    letter-spacing: 0.05em;\n    line-height: 13px;\n    padding: 0 4px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  .skd-rev-cur {\n    color: #fff;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n  }\n\n  .skd-rev-vs {\n    font-variant-numeric: tabular-nums;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-rev-footer {\n    align-items: baseline;\n    display: flex;\n    gap: 6px;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .skd-rev-ach {\n    font-weight: 500;\n    opacity: 0.75;\n  }\n\n  .skd-rev-footer-pct {\n    flex: none;\n    font-style: normal;\n    font-weight: 700;\n    margin-left: auto;\n  }\n\n  .skd-progress-marker {\n    background: #fbbf6b;\n    border-radius: 1px;\n    height: 11px;\n    position: absolute;\n    top: -3px;\n    width: 2px;\n  }\n\n  .skd-card-bottom {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    min-height: 28px;\n    padding-top: 0;\n  }\n\n  .skd-card-footer {\n    color: var(--skd-muted);\n    font-size: clamp(8px, 5cqi, 10px);\n    font-weight: 600;\n    letter-spacing: 0.01em;\n    line-height: 14px;\n    margin-top: 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-sparkline {\n    display: block;\n    height: 22px;\n    opacity: 1;\n    pointer-events: none;\n    position: absolute;\n    right: 8px;\n    top: 6px;\n    width: 52px;\n    z-index: 2;\n  }\n\n  .skd-progress-track {\n    background: #e2e8f0;\n    border-radius: 999px;\n    height: 4px;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  .skd-progress-fill {\n    background: #22c55e;\n    border-radius: 999px;\n    height: 100%;\n    transition: width 0.4s ease;\n  }\n\n  .skd-positive {\n    color: #16a34a;\n  }\n\n  .skd-danger {\n    color: #dc2626;\n  }\n\n  .skd-warning {\n    color: #d97706;\n  }\n\n  .skd-info {\n    color: #2563eb;\n  }\n\n  .skd-card--revenue,\n  .skd-card--throughput,\n  .skd-card--fleet,\n  .skd-card--pms,\n  .skd-card--risk,\n  .skd-card--outstanding {\n    border-color: transparent;\n  }\n\n  .skd-card--throughput,\n  .skd-card--fleet {\n    .skd-positive,\n    .skd-danger,\n    .skd-info {\n      color: rgba(255, 255, 255, 0.95);\n    }\n  }\n\n  // ── Widgets ──────────────────────────────────────────────\n  .skd-widget {\n    background: #fff;\n    border: 1px solid var(--skd-border);\n    border-radius: var(--skd-card-radius);\n    box-shadow: var(--skd-shadow);\n    height: 100%;\n    padding: 12px 14px;\n\n    &--fixed-h-lg {\n      display: flex;\n      flex-direction: column;\n      height: auto;\n      max-height: none;\n      min-height: 360px;\n      overflow: hidden;\n\n      @media (min-width: 1200px) {\n        height: 430px;\n        max-height: 430px;\n        min-height: 430px;\n      }\n    }\n\n    &--fixed-h-md {\n      display: flex;\n      flex-direction: column;\n      height: auto;\n      max-height: none;\n      min-height: 320px;\n      overflow: hidden;\n\n      @media (min-width: 1200px) {\n        height: 400px;\n        max-height: 400px;\n        min-height: 400px;\n      }\n    }\n\n    &--risk-panel {\n      display: flex;\n      flex-direction: column;\n      height: auto;\n      max-height: none;\n      min-height: 360px;\n      overflow: hidden;\n\n      @media (min-width: 1200px) {\n        height: 430px;\n        max-height: 430px;\n        min-height: 430px;\n      }\n    }\n\n    &--client-directory {\n      --mcd-ink: #1f2433;\n      --mcd-ink2: #3b4256;\n      --mcd-muted: #6b7280;\n      --mcd-faint: #9aa1ad;\n      --mcd-line: #e8eaf0;\n      --mcd-line2: #f0f2f6;\n      --mcd-track: #eef0f4;\n      --mcd-hover: #f7f9fc;\n      --mcd-blue: #2f80ed;\n      --mcd-green: #16a34a;\n      --mcd-orange: #e07b00;\n      --mcd-red: #dc2f2f;\n      --mcd-warn: #b45309;\n      --mcd-warn-s: #fff4e2;\n\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      height: auto;\n      max-height: none;\n      min-height: 320px;\n      overflow: hidden;\n      padding: 16px 16px 10px;\n\n      @media (min-width: 1200px) {\n        height: 480px;\n        max-height: 480px;\n        min-height: 480px;\n      }\n    }\n\n    &--penetration-panel,\n    &--scorecard-panel {\n      display: flex;\n      flex-direction: column;\n      height: auto;\n      max-height: none;\n      min-height: 320px;\n      overflow: hidden;\n\n      @media (min-width: 900px) {\n        height: 400px;\n        max-height: 400px;\n        min-height: 400px;\n      }\n\n      .skd-widget-title {\n        flex-shrink: 0;\n        margin-bottom: 14px;\n      }\n    }\n\n    &--penetration-panel {\n      .skd-penetration-panel-header {\n        align-items: center;\n        margin-bottom: 14px;\n\n        .skd-widget-title {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    &--scorecard-panel {\n      .skd-scorecard-panel-header {\n        align-items: center;\n        margin-bottom: 14px;\n\n        .skd-widget-title {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    &--product-mix {\n      --pmx-ink: #1f2433;\n      --pmx-ink2: #3b4256;\n      --pmx-muted: #6b7280;\n      --pmx-faint: #9aa1ad;\n      --pmx-line: #e8eaf0;\n      --pmx-track: #eef0f4;\n      --pmx-conv: #16a34a;\n      --pmx-pend: #f59e0b;\n\n      display: flex;\n      flex-direction: column;\n      gap: 14px;\n      height: auto;\n      max-height: none;\n      min-height: 320px;\n      overflow: hidden;\n      padding: 16px;\n\n      @media (min-width: 1200px) {\n        height: 480px;\n        max-height: 480px;\n        min-height: 480px;\n      }\n    }\n\n    &--fleet-make-model {\n      --fmm-ink: #1f2433;\n      --fmm-ink2: #3b4256;\n      --fmm-muted: #6b7280;\n      --fmm-faint: #9aa1ad;\n      --fmm-line: #e8eaf0;\n      --fmm-track: #e9ecf2;\n      --fmm-hover: #f6f8fc;\n      --fmm-blue: #2f80ed;\n\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      height: auto;\n      max-height: none;\n      min-height: 320px;\n      overflow: hidden;\n      padding: 16px 14px 12px;\n\n      @media (min-width: 1200px) {\n        height: 480px;\n        max-height: 480px;\n        min-height: 480px;\n      }\n    }\n  }\n\n  .skd-penetration-scroll,\n  .skd-scorecard-scroll {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    gap: 14px;\n    min-height: 0;\n    overflow-y: auto;\n  }\n\n  .skd-scorecard-panel-header {\n    align-items: center !important;\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    gap: 10px;\n    justify-content: space-between;\n    margin-bottom: 14px;\n    min-width: 0;\n    width: 100%;\n\n    .skd-widget-title {\n      align-items: center;\n      flex: 1 1 auto;\n      line-height: 1.2;\n      margin-bottom: 0 !important;\n      min-width: 0;\n      overflow: hidden;\n\n      > span {\n        flex: 1 1 auto;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .skd-scorecard-search {\n    flex: 0 0 auto;\n    width: 150px;\n  }\n\n  .skd-scorecard-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-x: auto;\n    overflow-y: auto;\n    width: 100%;\n  }\n\n  .skd-penetration-row {\n    flex-shrink: 0;\n  }\n\n  .skd-penetration-panel-header {\n    align-items: center !important;\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    gap: 10px;\n    justify-content: space-between;\n    margin-bottom: 14px;\n    min-width: 0;\n    width: 100%;\n\n    .skd-widget-title {\n      align-items: center;\n      flex: 1 1 auto;\n      line-height: 1.2;\n      margin-bottom: 0 !important;\n      min-width: 0;\n      overflow: hidden;\n\n      > span {\n        flex: 1 1 auto;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    .skd-penetration-toggle {\n      align-self: center;\n      flex: 0 0 auto;\n      margin-top: 0;\n    }\n  }\n\n  .skd-penetration-toggle {\n    align-items: center;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 2px;\n    height: 34px;\n    padding: 3px;\n  }\n\n  .skd-penetration-tab {\n    align-items: center;\n    background: transparent;\n    border: none;\n    border-radius: 9px;\n    color: #64748b;\n    cursor: pointer;\n    display: inline-flex;\n    height: 28px;\n    justify-content: center;\n    line-height: 1;\n    min-width: 34px;\n    padding: 0 8px;\n    transition:\n      background 0.18s ease,\n      color 0.18s ease,\n      box-shadow 0.18s ease;\n\n    .skd-penetration-tab-icon {\n      align-items: center;\n      display: inline-flex;\n      justify-content: center;\n      line-height: 0;\n\n      .MuiSvgIcon-root {\n        display: block;\n        font-size: 18px;\n      }\n    }\n\n    &:hover:not(.is-active) {\n      background: rgba(255, 255, 255, 0.7);\n      color: #334155;\n    }\n\n    &.is-active {\n      background: #fff;\n      box-shadow:\n        0 1px 2px rgba(15, 23, 42, 0.06),\n        0 4px 10px rgba(15, 23, 42, 0.06);\n    }\n\n    &--vehicle.is-active {\n      color: #2563eb;\n    }\n\n    &--garage.is-active {\n      color: #0f766e;\n    }\n  }\n\n  .skd-penetration-header {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n\n  .skd-penetration-name {\n    color: #334155;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .skd-penetration-pct {\n    font-size: 13px;\n    font-weight: 700;\n\n    &--high {\n      color: #16a34a;\n    }\n\n    &--mid {\n      color: #d97706;\n    }\n\n    &--low {\n      color: #dc2626;\n    }\n  }\n\n  .skd-penetration-count {\n    font-size: 13px;\n    font-weight: 700;\n\n    &.skd-penetration-pct--high {\n      color: #16a34a;\n    }\n\n    &.skd-penetration-pct--mid {\n      color: #d97706;\n    }\n\n    &.skd-penetration-pct--low {\n      color: #dc2626;\n    }\n  }\n\n  .skd-penetration-track {\n    background: #e2e8f0;\n    border-radius: 999px;\n    height: 8px;\n    overflow: hidden;\n    width: 100%;\n  }\n\n  .skd-penetration-fill {\n    border-radius: 999px;\n    display: block;\n    height: 100%;\n    transition: width 0.4s ease;\n\n    &--high {\n      background: linear-gradient(90deg, #22c55e, #16a34a);\n    }\n\n    &--mid {\n      background: linear-gradient(90deg, #fbbf24, #f59e0b);\n    }\n\n    &--low {\n      background: linear-gradient(90deg, #f87171, #ef4444);\n    }\n  }\n\n  .skd-scorecard-table {\n    min-width: 0;\n    width: 100%;\n\n    th,\n    td {\n      font-size: 12px;\n      padding: 8px 6px;\n      vertical-align: middle;\n    }\n\n    th {\n      color: var(--skd-muted);\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.02em;\n      text-transform: uppercase;\n      white-space: nowrap;\n    }\n\n    th.skd-col-accounts,\n    td.skd-col-accounts {\n      color: #16a34a;\n      font-weight: 700;\n    }\n\n    th.skd-col-vehicles,\n    td.skd-col-vehicles {\n      color: #0891b2;\n      font-weight: 700;\n    }\n\n    th.skd-col-outstanding,\n    td.skd-col-outstanding {\n      color: #d97706;\n      font-weight: 700;\n    }\n\n    td.skd-scorecard-outstanding--low {\n      color: #b45309;\n    }\n\n    td.skd-scorecard-outstanding--mid {\n      color: #d97706;\n    }\n\n    td.skd-scorecard-outstanding--high {\n      color: #dc2626;\n    }\n\n    th:nth-child(2),\n    th:nth-child(3),\n    td:nth-child(2),\n    td:nth-child(3) {\n      text-align: center;\n    }\n\n    th:last-child,\n    td:last-child {\n      text-align: right;\n    }\n\n    tbody tr {\n      border-top: 1px solid #e2e8f0;\n    }\n  }\n\n  .skd-scorecard-am {\n    color: var(--skd-text);\n    font-weight: 600;\n    overflow-wrap: anywhere;\n    white-space: normal;\n  }\n\n  .skd-scorecard-outstanding {\n    white-space: nowrap;\n\n    &--low {\n      color: #b45309;\n    }\n\n    &--mid {\n      color: #d97706;\n    }\n\n    &--high {\n      color: #dc2626;\n    }\n  }\n\n  .skd-risk-panel-header {\n    align-items: center !important;\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    gap: 8px;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    min-width: 0;\n    width: 100%;\n\n    .skd-widget-title {\n      align-items: center;\n      flex: 1 1 auto;\n      font-size: 12px;\n      gap: 4px;\n      letter-spacing: 0.02em;\n      line-height: 1.2;\n      margin-bottom: 0;\n      min-width: 0;\n      white-space: nowrap;\n\n      > span {\n        flex: 0 1 auto;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .skd-risk-search {\n    flex: 0 0 auto;\n    width: 130px;\n  }\n\n  .skd-client-directory-header {\n    flex-shrink: 0;\n    margin-bottom: 10px;\n  }\n\n  .skd-mcd__head {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    gap: 8px;\n  }\n\n  .skd-mcd__title {\n    color: var(--mcd-ink, var(--skd-text));\n    flex: 1;\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    margin: 0;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  .skd-mcd__tot {\n    background: var(--mcd-line, var(--skd-border));\n    border: 1px solid var(--mcd-line, var(--skd-border));\n    border-radius: 10px;\n    display: grid;\n    flex-shrink: 0;\n    gap: 1px;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    overflow: hidden;\n\n    > div {\n      background: #fff;\n      min-width: 0;\n      padding: 8px 12px;\n    }\n\n    small {\n      color: var(--mcd-muted, var(--skd-muted));\n      display: block;\n      font-size: 11px;\n      font-weight: 600;\n      letter-spacing: 0.05em;\n      text-transform: uppercase;\n    }\n\n    b,\n    .skd-mcd__tot-val {\n      color: var(--mcd-ink, var(--skd-text));\n      display: block;\n      font-size: 16px;\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      margin-top: 2px;\n      white-space: nowrap;\n    }\n\n    .skd-mcd__tot-val--out {\n      color: var(--mcd-orange);\n    }\n\n    .skd-mcd__tot-val--od {\n      color: var(--mcd-red);\n    }\n  }\n\n  .skd-mcd__tools {\n    display: flex;\n    flex-shrink: 0;\n    gap: 8px;\n  }\n\n  .skd-mcd__search {\n    align-items: center;\n    border: 1px solid var(--mcd-line, var(--skd-border));\n    border-radius: 8px;\n    color: var(--mcd-faint, var(--skd-muted));\n    display: flex;\n    flex: 1;\n    gap: 8px;\n    height: 34px;\n    min-width: 0;\n    padding: 0 10px;\n\n    &:focus-within {\n      border-color: var(--mcd-blue);\n    }\n\n    input {\n      background: transparent;\n      border: 0;\n      color: var(--mcd-ink, var(--skd-text));\n      font: inherit;\n      font-size: 13px;\n      min-width: 0;\n      outline: 0;\n      width: 100%;\n\n      &::placeholder {\n        color: var(--mcd-faint, var(--skd-muted));\n      }\n    }\n  }\n\n  .skd-mcd__search-icon {\n    color: inherit;\n    flex: none;\n    font-size: 16px !important;\n  }\n\n  .skd-mcd__sort {\n    background: #fff;\n    border: 1px solid var(--mcd-line, var(--skd-border));\n    border-radius: 8px;\n    color: var(--mcd-ink2, var(--skd-text));\n    cursor: pointer;\n    flex: none;\n    font-family: inherit;\n    font-size: 12.5px;\n    font-weight: 500;\n    height: 34px;\n    max-width: 46%;\n    padding: 0 8px;\n  }\n\n  .skd-mcd__list {\n    flex: 1 1 auto;\n    list-style: none;\n    margin: 0 -6px;\n    min-height: 0;\n    padding: 0 6px;\n  }\n\n  .skd-mcd__row {\n    border-bottom: 1px solid var(--mcd-line2, #f0f2f6);\n    border-radius: 6px;\n    display: grid;\n    gap: 3px 12px;\n    grid-template-columns: minmax(0, 1fr) auto;\n    padding: 10px 8px;\n\n    &:hover {\n      background: var(--mcd-hover, #f7f9fc);\n    }\n  }\n\n  .skd-mcd__name {\n    color: var(--mcd-ink, var(--skd-text));\n    display: -webkit-box;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.3;\n    min-width: 0;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  .skd-mcd__od {\n    color: var(--mcd-muted, var(--skd-muted));\n    font-size: 12px;\n    text-align: right;\n    white-space: nowrap;\n\n    b {\n      color: var(--mcd-red);\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n    }\n  }\n\n  .skd-mcd__meta {\n    align-items: center;\n    color: var(--mcd-muted, var(--skd-muted));\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 12px;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .skd-mcd__fl {\n    color: var(--mcd-blue);\n    font-weight: 600;\n  }\n\n  .skd-mcd__pn {\n    color: var(--mcd-green);\n    font-weight: 600;\n\n    &--hi {\n      background: var(--mcd-warn-s);\n      border-radius: 5px;\n      color: var(--mcd-warn);\n      padding: 0 5px;\n    }\n  }\n\n  .skd-mcd__sep {\n    background: var(--mcd-faint, var(--skd-muted));\n    border-radius: 50%;\n    display: inline-block;\n    height: 3px;\n    width: 3px;\n  }\n\n  .skd-mcd__os {\n    color: var(--mcd-muted, var(--skd-muted));\n    font-size: 12px;\n    text-align: right;\n    white-space: nowrap;\n\n    b {\n      color: var(--mcd-orange);\n      font-variant-numeric: tabular-nums;\n      font-weight: 600;\n    }\n  }\n\n  .skd-mcd__bar {\n    background: var(--mcd-track, #eef0f4);\n    border-radius: 9px;\n    grid-column: 1 / -1;\n    height: 4px;\n    margin-top: 3px;\n    overflow: hidden;\n\n    i {\n      background: linear-gradient(90deg, #f59e0b, #dc2f2f);\n      border-radius: 9px;\n      display: block;\n      height: 100%;\n    }\n  }\n\n  .skd-mcd__empty {\n    color: var(--mcd-muted, var(--skd-muted));\n    padding: 28px 8px;\n    text-align: center;\n  }\n\n  .skd-mcd__foot {\n    color: var(--mcd-faint, var(--skd-muted));\n    display: flex;\n    flex-shrink: 0;\n    font-size: 12px;\n    justify-content: space-between;\n    padding-top: 2px;\n  }\n\n  .skd-risk-panel-scroll {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 0;\n  }\n\n  .skd-scroll-area {\n    flex: 1 1 auto;\n    margin-bottom: 0;\n    max-height: 100%;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding-right: 4px;\n    @include dash-scrollbar(6px);\n  }\n\n  .skd-widget-header {\n    align-items: flex-start;\n    display: flex;\n    flex-shrink: 0;\n    gap: 12px;\n    justify-content: space-between;\n    margin-bottom: 14px;\n  }\n\n  .skd-widget-title {\n    align-items: center;\n    color: var(--skd-text);\n    display: flex;\n    font-size: 13px;\n    font-weight: 700;\n    gap: 6px;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n\n    &--danger {\n      color: #dc2626;\n    }\n  }\n\n  .skd-widget-info {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    line-height: 0;\n    text-transform: none;\n  }\n\n  .skd-widget-info-icon {\n    color: var(--skd-muted);\n    font-size: 15px !important;\n  }\n\n  .skd-widget-subtitle {\n    color: var(--skd-muted);\n    font-size: 12px;\n    margin-top: 4px;\n  }\n\n  .skd-widget-controls {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    gap: 10px;\n  }\n\n  .skd-period-toggle {\n    background: #f1f5f9;\n    border-radius: 999px;\n    display: inline-flex;\n    padding: 3px;\n\n    button {\n      background: transparent;\n      border: none;\n      border-radius: 999px;\n      color: var(--skd-muted);\n      cursor: pointer;\n      font-size: 11px;\n      font-weight: 600;\n      padding: 6px 12px;\n      transition: all 0.2s;\n\n      &.active {\n        background: #334155;\n        box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);\n        color: #fff;\n      }\n\n      &:not(.active):hover {\n        color: var(--skd-text);\n      }\n    }\n  }\n\n  .skd-live-badge {\n    align-items: center;\n    background: #fff;\n    border: 1px solid var(--skd-border);\n    border-radius: 999px;\n    box-shadow: var(--skd-shadow-soft);\n    color: var(--skd-muted);\n    display: inline-flex;\n    font-size: 11px;\n    font-weight: 600;\n    gap: 6px;\n    padding: 6px 12px;\n    white-space: nowrap;\n  }\n\n  .skd-live-dot {\n    animation: skd-pulse 2s infinite;\n    background: #22c55e;\n    border-radius: 50%;\n    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.2);\n    height: 8px;\n    width: 8px;\n  }\n\n  @keyframes skd-pulse {\n    0%,\n    100% {\n      opacity: 1;\n    }\n\n    50% {\n      opacity: 0.55;\n    }\n  }\n\n  .skd-priority-badge {\n    background: #fee2e2;\n    border-radius: 999px;\n    color: #dc2626;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    padding: 5px 12px;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  // ── Fleet at risk list ───────────────────────────────────\n  .skd-risk-list-item {\n    align-items: center;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    display: grid;\n    gap: 10px;\n    grid-template-columns: minmax(0, 1fr) 100px auto;\n    padding: 12px 14px;\n  }\n\n  .skd-risk-client {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    justify-content: center;\n    min-width: 0;\n  }\n\n  .skd-risk-account-name {\n    color: var(--skd-text);\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-risk-am {\n    color: var(--skd-muted);\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1.3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-risk-count {\n    font-size: 12px;\n    font-weight: 700;\n    text-align: right;\n    white-space: nowrap;\n  }\n\n  .skd-risk-bar-wrap {\n    min-width: 80px;\n    width: 100px;\n  }\n\n  .skd-risk-bar {\n    background: #e2e8f0;\n    border-radius: 999px;\n    height: 6px;\n    overflow: hidden;\n\n    span {\n      background: linear-gradient(90deg, #fdba74, #ef4444);\n      border-radius: 999px;\n      display: block;\n      height: 100%;\n      min-width: 4px;\n    }\n  }\n\n  .skd-action-btn {\n    background: #fff;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    color: var(--skd-muted);\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 6px 10px;\n    white-space: nowrap;\n\n    &:hover {\n      background: #f8fafc;\n      border-color: #94a3b8;\n    }\n  }\n\n  .skd-nudge-btn {\n    align-items: center;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.28);\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    flex-shrink: 0;\n    font-size: 12px;\n    font-weight: 700;\n    gap: 8px;\n    justify-content: center;\n    margin-top: auto;\n    padding: 12px;\n    width: 100%;\n\n    &:hover {\n      filter: brightness(1.05);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.65;\n    }\n  }\n\n  // ── Product mix & PMS conversion ─────────────────────────\n  .skd-pmx__head {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    gap: 8px;\n  }\n\n  .skd-pmx__title {\n    color: var(--pmx-ink, var(--skd-text));\n    flex: 1;\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    line-height: 1.3;\n    margin: 0;\n    min-width: 0;\n    text-transform: uppercase;\n  }\n\n  .skd-pmx__body {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    gap: 14px;\n    min-height: 0;\n    overflow: auto;\n    @include dash-scrollbar(6px);\n  }\n\n  .skd-pmx__sec {\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 9px;\n\n    &--pms {\n      border-top: 1px solid var(--pmx-line, var(--skd-border));\n      padding-top: 14px;\n    }\n  }\n\n  .skd-pmx__label {\n    color: var(--pmx-muted, var(--skd-muted));\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n\n  .skd-pmx__bar,\n  .skd-pmx__cbar {\n    background: var(--pmx-track, #eef0f4);\n    border-radius: 99px;\n    display: flex;\n    gap: 2px;\n    overflow: hidden;\n\n    i {\n      display: block;\n      height: 100%;\n      min-width: 0;\n    }\n  }\n\n  .skd-pmx__bar {\n    height: 14px;\n\n    i {\n      min-width: 3px;\n    }\n  }\n\n  .skd-pmx__cbar {\n    height: 10px;\n  }\n\n  .skd-pmx__leg {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      align-items: center;\n      color: var(--pmx-ink, var(--skd-text));\n      display: grid;\n      font-size: 13px;\n      gap: 8px;\n      grid-template-columns: 10px minmax(0, 1fr) auto;\n    }\n\n    b {\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      white-space: nowrap;\n    }\n  }\n\n  .skd-pmx__leg-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .skd-pmx__dot {\n    border-radius: 3px;\n    display: block;\n    height: 10px;\n    width: 10px;\n  }\n\n  .skd-pmx__big {\n    align-items: baseline;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    b {\n      color: var(--pmx-conv, #16a34a);\n      font-size: 28px;\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      line-height: 1;\n    }\n\n    span {\n      color: var(--pmx-muted, var(--skd-muted));\n      font-size: 12.5px;\n      line-height: 1.35;\n    }\n  }\n\n  .skd-pmx__stats {\n    display: grid;\n    gap: 8px;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .skd-pmx__st {\n    border: 1px solid;\n    border-radius: 9px;\n    min-width: 0;\n    padding: 8px 10px;\n\n    small {\n      color: var(--pmx-ink2, var(--skd-text));\n      display: block;\n      font-size: 10.5px;\n      font-weight: 600;\n      letter-spacing: 0.04em;\n      line-height: 1.3;\n      text-transform: uppercase;\n    }\n\n    b {\n      display: block;\n      font-size: 17px;\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n      margin-top: 2px;\n      white-space: nowrap;\n    }\n\n    em {\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      margin-left: 4px;\n    }\n\n    &--all {\n      align-items: center;\n      background: #f0f6ff;\n      border-color: #d7e6fb;\n      display: flex;\n      grid-column: 1 / -1;\n      justify-content: space-between;\n\n      b {\n        font-size: 18px;\n        margin-top: 0;\n      }\n    }\n\n    &--cv {\n      background: #effaf3;\n      border-color: #cdeedb;\n\n      em {\n        color: var(--pmx-conv, #16a34a);\n      }\n    }\n\n    &--pd {\n      background: #fff8ee;\n      border-color: #fbe3bf;\n\n      em {\n        color: #b45309;\n      }\n    }\n  }\n\n  // ── Fleet make & model ───────────────────────────────────\n  .skd-fmm__head {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .skd-fmm__title {\n    color: var(--fmm-ink, var(--skd-text));\n    flex: 1 1 120px;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    margin: 0;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  .skd-fmm__seg {\n    background: #f1f3f8;\n    border-radius: 10px;\n    display: inline-flex;\n    flex: none;\n    gap: 2px;\n    margin-left: auto;\n    padding: 3px;\n\n    button {\n      align-items: center;\n      background: none;\n      border: 0;\n      border-radius: 8px;\n      color: var(--fmm-muted, var(--skd-muted));\n      cursor: pointer;\n      display: inline-flex;\n      font: inherit;\n      font-size: 11px;\n      font-weight: 600;\n      gap: 4px;\n      height: 28px;\n      padding: 0 8px;\n\n      &.is-active,\n      &[aria-pressed=\"true\"] {\n        background: #fff;\n        box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);\n        color: var(--fmm-blue, #2f80ed);\n      }\n    }\n  }\n\n  .skd-fmm__sum {\n    align-items: baseline;\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    gap: 14px;\n  }\n\n  .skd-fmm__big {\n    color: var(--fmm-ink, var(--skd-text));\n    font-size: 28px;\n    font-variant-numeric: tabular-nums;\n    font-weight: 700;\n    line-height: 1;\n\n    small {\n      color: var(--fmm-muted, var(--skd-muted));\n      font-size: 13px;\n      font-weight: 500;\n      margin-left: 5px;\n    }\n  }\n\n  .skd-fmm__meta {\n    color: var(--fmm-muted, var(--skd-muted));\n    font-size: 12.5px;\n\n    b {\n      color: var(--fmm-ink2, var(--skd-text));\n      font-weight: 700;\n    }\n  }\n\n  .skd-fmm__share {\n    background: var(--fmm-track, #e9ecf2);\n    border-radius: 99px;\n    display: flex;\n    flex-shrink: 0;\n    gap: 2px;\n    height: 12px;\n    overflow: hidden;\n\n    &:hover i {\n      opacity: 0.55;\n    }\n\n    i {\n      cursor: pointer;\n      display: block;\n      height: 100%;\n      transition: opacity 0.15s;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .skd-fmm__legend {\n    color: var(--fmm-ink2, var(--skd-text));\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    font-size: 12px;\n    gap: 4px 14px;\n    margin-top: -6px;\n\n    span {\n      align-items: center;\n      display: inline-flex;\n      gap: 6px;\n    }\n\n    i {\n      border-radius: 3px;\n      display: inline-block;\n      height: 9px;\n      width: 9px;\n    }\n\n    b {\n      font-variant-numeric: tabular-nums;\n      font-weight: 700;\n    }\n  }\n\n  .skd-fmm__search {\n    align-items: center;\n    border: 1px solid var(--fmm-line, var(--skd-border));\n    border-radius: 8px;\n    color: var(--fmm-faint, var(--skd-muted));\n    display: flex;\n    flex-shrink: 0;\n    gap: 8px;\n    height: 36px;\n    padding: 0 10px;\n\n    &:focus-within {\n      border-color: var(--fmm-blue, #2f80ed);\n    }\n\n    input {\n      background: transparent;\n      border: 0;\n      color: var(--fmm-ink, var(--skd-text));\n      font: inherit;\n      font-size: 13px;\n      outline: 0;\n      width: 100%;\n\n      &::placeholder {\n        color: var(--fmm-faint, var(--skd-muted));\n      }\n    }\n  }\n\n  .skd-fmm__search-icon {\n    color: inherit;\n    flex: none;\n    font-size: 16px !important;\n  }\n\n  .skd-fmm__list {\n    flex: 1 1 auto;\n    list-style: none;\n    margin: 0 -6px;\n    min-height: 0;\n    padding: 0 6px;\n  }\n\n  .skd-fmm__row {\n    align-items: center;\n    background: none;\n    border: 0;\n    border-radius: 8px;\n    color: inherit;\n    cursor: pointer;\n    display: grid;\n    font: inherit;\n    gap: 5px 10px;\n    grid-template-columns: 18px minmax(0, 1fr) auto;\n    padding: 8px 6px;\n    text-align: left;\n    width: 100%;\n\n    &:hover {\n      background: var(--fmm-hover, #f6f8fc);\n    }\n\n    &--flat {\n      cursor: default;\n      grid-template-columns: minmax(0, 1fr) auto;\n\n      .skd-fmm__bar {\n        grid-column: 1 / -1;\n      }\n    }\n\n    &[aria-expanded=\"true\"] .skd-fmm__chev {\n      color: var(--fmm-blue, #2f80ed);\n      transform: rotate(90deg);\n    }\n  }\n\n  .skd-fmm__chev {\n    color: var(--fmm-faint, var(--skd-muted));\n    font-size: 18px !important;\n    transition: transform 0.15s;\n  }\n\n  .skd-fmm__nm {\n    font-size: 14px;\n    font-weight: 600;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    small {\n      color: var(--fmm-faint, var(--skd-muted));\n      font-size: 12px;\n      font-weight: 400;\n      margin-left: 6px;\n    }\n  }\n\n  .skd-fmm__val {\n    font-variant-numeric: tabular-nums;\n    font-weight: 700;\n    white-space: nowrap;\n\n    small {\n      color: var(--fmm-faint, var(--skd-muted));\n      display: inline-block;\n      font-size: 11.5px;\n      font-weight: 500;\n      margin-left: 6px;\n      min-width: 38px;\n      text-align: right;\n    }\n  }\n\n  .skd-fmm__bar {\n    background: var(--fmm-track, #e9ecf2);\n    border-radius: 99px;\n    grid-column: 2 / -1;\n    height: 7px;\n    overflow: hidden;\n\n    i {\n      border-radius: 99px;\n      display: block;\n      height: 100%;\n    }\n  }\n\n  .skd-fmm__sub {\n    border-left: 2px solid var(--fmm-line, var(--skd-border));\n    list-style: none;\n    margin: 0 0 6px 14px;\n    padding: 2px 0 6px 34px;\n\n    li {\n      align-items: center;\n      display: grid;\n      font-size: 13px;\n      gap: 3px 10px;\n      grid-template-columns: minmax(0, 1fr) auto;\n      padding: 5px 6px;\n    }\n\n    .skd-fmm__val {\n      font-weight: 600;\n    }\n\n    .skd-fmm__bar {\n      grid-column: 1 / -1;\n      height: 5px;\n\n      i {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .skd-fmm__empty {\n    color: var(--fmm-muted, var(--skd-muted));\n    padding: 28px 6px;\n    text-align: center;\n  }\n\n  .skd-fmm__foot {\n    align-items: center;\n    border-top: 1px solid var(--fmm-line, var(--skd-border));\n    color: var(--fmm-faint, var(--skd-muted));\n    display: flex;\n    flex-shrink: 0;\n    font-size: 12px;\n    justify-content: space-between;\n    padding-top: 10px;\n\n    button {\n      background: none;\n      border: 0;\n      color: var(--fmm-blue, #2f80ed);\n      cursor: pointer;\n      font: inherit;\n      font-size: 12px;\n      font-weight: 600;\n      padding: 2px 4px;\n    }\n  }\n\n  // ── Client directory table ─────────────────────────────────\n  .skd-table-toolbar {\n    align-items: center;\n    display: flex;\n    gap: 10px;\n  }\n\n  .skd-filter-select {\n    background: #fff;\n    border: 1px solid var(--skd-border);\n    border-radius: 8px;\n    color: var(--skd-muted);\n    font-size: 12px;\n    font-weight: 600;\n    outline: none;\n    padding: 8px 10px;\n  }\n\n  .skd-search-wrap {\n    position: relative;\n    width: 180px;\n  }\n\n  .skd-search-input {\n    background: #fff;\n    border: 1px solid var(--skd-border);\n    border-radius: 8px;\n    color: var(--skd-text);\n    font-size: 12px;\n    outline: none;\n    padding: 8px 12px 8px 32px;\n    width: 100%;\n\n    &::placeholder {\n      color: #94a3b8;\n    }\n\n    &:focus {\n      border-color: #93c5fd;\n      box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n    }\n  }\n\n  .skd-search-icon {\n    color: #94a3b8;\n    font-size: 16px !important;\n    left: 9px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .skd-table-wrap {\n    flex: 1 1 auto;\n    margin-top: 0;\n    min-height: 0;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    @include dash-scrollbar(6px);\n  }\n\n  .skd-table {\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n\n    .skd-sort-btn {\n      align-items: center;\n      background: transparent;\n      border: none;\n      color: inherit;\n      cursor: pointer;\n      display: inline-flex;\n      font: inherit;\n      font-size: 10px;\n      font-weight: 700;\n      gap: 2px;\n      letter-spacing: 0.06em;\n      padding: 0;\n      text-transform: uppercase;\n      white-space: nowrap;\n\n      &:hover {\n        opacity: 0.85;\n      }\n\n      &--active {\n        text-decoration: underline;\n        text-underline-offset: 2px;\n      }\n\n      &--fleet {\n        color: #2563eb;\n      }\n\n      &--throughput {\n        color: #16a34a;\n      }\n\n      &--outstanding {\n        color: #d97706;\n      }\n\n      &--overdue {\n        color: #dc2626;\n      }\n    }\n\n    .skd-sort-indicator {\n      font-size: 11px;\n      line-height: 1;\n    }\n\n    thead th {\n      position: sticky;\n      top: 0;\n      z-index: 2;\n    }\n\n    th,\n    td {\n      font-size: 12px;\n      padding: 11px 12px;\n      text-align: left;\n    }\n\n    th {\n      background: #f8fafc;\n      border-bottom: 1px solid var(--skd-border);\n      box-shadow: 0 1px 0 var(--skd-border);\n      color: var(--skd-muted);\n      font-size: 10px;\n      font-weight: 700;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n    }\n\n    td {\n      border-bottom: 1px solid #f1f5f9;\n      color: var(--skd-text);\n    }\n\n    th.skd-col-fleet,\n    td.skd-col-fleet {\n      color: #2563eb;\n      font-weight: 700;\n    }\n\n    th.skd-col-throughput,\n    td.skd-col-throughput {\n      color: #16a34a;\n      font-weight: 700;\n    }\n\n    th.skd-col-outstanding,\n    td.skd-col-outstanding {\n      color: #d97706;\n      font-weight: 700;\n    }\n\n    th.skd-col-overdue,\n    td.skd-col-overdue {\n      color: #dc2626;\n      font-weight: 700;\n      width: 100px;\n    }\n\n    th.skd-col-accounts,\n    td.skd-col-accounts {\n      color: #16a34a;\n      font-weight: 700;\n    }\n\n    th.skd-col-vehicles,\n    td.skd-col-vehicles {\n      color: #0891b2;\n      font-weight: 700;\n    }\n\n    tbody tr:nth-child(even) td {\n      background: #f8fafc;\n    }\n\n    tbody tr:hover td {\n      background: #eff6ff;\n    }\n  }\n\n  .skd-view-btn {\n    background: #fff;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    color: var(--skd-muted);\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 10px;\n\n    &:hover {\n      background: #f8fafc;\n    }\n  }\n\n  // ── AR breakdown ─────────────────────────────────────────\n  .skd-ar-layout {\n    container-type: inline-size;\n    display: grid;\n    gap: 6px;\n    grid-template-rows: auto minmax(0, 1fr) auto;\n    height: auto;\n    max-height: none;\n    max-width: 100%;\n    min-height: 300px;\n    min-width: 0;\n    overflow: hidden;\n    padding: 12px 14px 10px;\n\n    @media (min-width: 1200px) {\n      &.skd-widget--fixed-h-md {\n        height: 400px;\n        max-height: 400px;\n        min-height: 400px;\n      }\n    }\n  }\n\n  .skd-ar-title {\n    grid-row: 1;\n    line-height: 1.2;\n    margin: 0;\n    text-align: left;\n  }\n\n  .skd-ar-chart-wrap {\n    align-items: center;\n    display: flex;\n    grid-row: 2;\n    height: 180px;\n    justify-content: center;\n    line-height: 0;\n    max-width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n\n    > div,\n    .highcharts-container,\n    .highcharts-root,\n    svg {\n      max-width: 100% !important;\n    }\n\n    > div,\n    .highcharts-container {\n      height: 180px !important;\n      width: 100% !important;\n    }\n  }\n\n  .skd-ar-legend {\n    display: none;\n  }\n\n  .skd-ar-stats-side {\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    gap: 6px;\n    grid-row: 3;\n    margin-top: 0;\n  }\n\n  .skd-ar-stat-card {\n    align-items: center;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    display: flex;\n    flex-shrink: 0;\n    gap: 8px;\n    min-height: 36px;\n    padding: 8px 10px;\n    transition: box-shadow 0.2s ease;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);\n    }\n\n    &--outstanding {\n      background: #fff7ed;\n      border-color: #fed7aa;\n      color: #b45309;\n\n      .skd-ar-stat-icon {\n        background: #f59e0b;\n      }\n    }\n\n    &--overdue {\n      background: #fef2f2;\n      border-color: #fecaca;\n      color: #dc2626;\n\n      .skd-ar-stat-icon {\n        background: #ef4444;\n      }\n    }\n\n    &--collected {\n      background: #ecfdf5;\n      border-color: #bbf7d0;\n      color: #15803d;\n\n      .skd-ar-stat-icon {\n        background: #22c55e;\n      }\n    }\n  }\n\n  .skd-ar-stat-icon {\n    border-radius: 50%;\n    flex-shrink: 0;\n    height: 10px;\n    width: 10px;\n  }\n\n  .skd-ar-stat-content {\n    align-items: center;\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    gap: 8px;\n    justify-content: space-between;\n    min-width: 0;\n  }\n\n  .skd-ar-stat-label,\n  .skd-ar-stat-value {\n    color: inherit;\n    font-size: clamp(10px, 2.5vw, 11px);\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 1.35;\n    text-transform: none;\n  }\n\n  .skd-ar-stat-label {\n    flex: 1;\n    min-width: 0;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .skd-ar-stat-value {\n    flex-shrink: 0;\n    max-width: 45%;\n    overflow-wrap: anywhere;\n    text-align: right;\n    word-break: break-word;\n  }\n\n  .skd-donut-stats {\n    border-top: 1px solid #f1f5f9;\n    display: grid;\n    gap: 10px;\n    margin-top: 14px;\n    padding-top: 14px;\n  }\n\n  .skd-stat-row {\n    align-items: center;\n    display: flex;\n    font-size: 12px;\n    justify-content: space-between;\n\n    span:first-child {\n      color: var(--skd-muted);\n      font-weight: 500;\n    }\n\n    span:last-child {\n      color: var(--skd-text);\n      font-weight: 700;\n    }\n  }\n\n  .skd-commented-widget {\n    opacity: 0.45;\n    pointer-events: none;\n    position: relative;\n\n    &::after {\n      align-items: center;\n      background: rgba(255, 255, 255, 0.8);\n      border-radius: var(--skd-card-radius);\n      color: var(--skd-muted);\n      content: \"Coming soon\";\n      display: flex;\n      font-size: 13px;\n      font-weight: 600;\n      inset: 0;\n      justify-content: center;\n      position: absolute;\n    }\n  }\n\n  // ── Responsive ───────────────────────────────────────────\n  @media (max-width: 1199px) {\n    padding: 16px 14px 24px;\n\n    .skd-widget-header {\n      flex-wrap: wrap;\n    }\n\n    .skd-table-toolbar {\n      flex-wrap: wrap;\n      justify-content: flex-end;\n      width: 100%;\n    }\n\n    .skd-search-wrap {\n      flex: 1;\n      min-width: 140px;\n      width: auto;\n    }\n\n    .skd-pmx__stats {\n      grid-template-columns: 1fr 1fr;\n    }\n\n    .skd-risk-list-item {\n      grid-template-columns: minmax(0, 1fr) auto;\n      row-gap: 8px;\n\n      .skd-risk-bar-wrap {\n        grid-column: 1 / -1;\n        width: 100%;\n      }\n    }\n\n    .skd-widget--risk-panel,\n    .skd-widget--client-directory,\n    .skd-widget--penetration-panel,\n    .skd-widget--scorecard-panel,\n    .skd-widget--product-mix,\n    .skd-widget--fleet-make-model,\n    .skd-widget--fixed-h-lg,\n    .skd-widget--fixed-h-md {\n      min-height: 300px;\n    }\n\n    .skd-period-toggle {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n\n    .skd-widget-controls {\n      flex-wrap: wrap;\n      justify-content: flex-end;\n    }\n\n    .skd-penetration-panel-header {\n      align-items: center;\n      flex-wrap: nowrap;\n    }\n\n    .skd-penetration-toggle {\n      width: auto;\n\n      button {\n        flex: 0 0 auto;\n      }\n    }\n  }\n\n  @media (max-width: 899px) {\n    margin: -12px;\n    padding: 10px 10px 20px;\n\n    .skd-page-header {\n      align-items: stretch;\n      flex-direction: column;\n    }\n\n    .skd-filter-actions {\n      width: 100%;\n    }\n\n    .skd-date-filter-wrap,\n    .skd-city-filter-wrap,\n    .skd-am-filter-wrap,\n    .skd-search-btn-wrap {\n      flex: 1 1 100%;\n      min-width: 0;\n      width: 100%;\n    }\n\n    .skd-search-btn-wrap button {\n      width: 100%;\n    }\n\n    .skd-global-search {\n      max-width: none;\n    }\n\n    .skd-page-title {\n      font-size: 16px;\n      white-space: normal;\n    }\n\n    .skd-mix-stats .skd-mix-stat-box {\n      flex: 1 1 100%;\n    }\n\n    .skd-mix-stat-value {\n      font-size: 18px;\n    }\n\n    .skd-ar-stat-content {\n      align-items: flex-start;\n      flex-wrap: wrap;\n      gap: 4px;\n    }\n\n    .skd-ar-stat-value {\n      max-width: 100%;\n      text-align: left;\n      width: 100%;\n    }\n\n    .skd-table-wrap {\n      -webkit-overflow-scrolling: touch;\n    }\n\n    .skd-table {\n      min-width: 520px;\n    }\n\n    .skd-scorecard-table {\n      min-width: 0;\n    }\n  }\n\n  @media (max-width: 599px) {\n    .skd-widget {\n      padding: 14px 12px;\n    }\n\n    .skd-card {\n      min-height: 108px;\n      padding: 10px;\n    }\n\n    .skd-widget-title {\n      font-size: 11px;\n    }\n\n    .skd-filter-select,\n    .skd-search-input {\n      font-size: 11px;\n      width: 100%;\n    }\n\n    .skd-table-toolbar {\n      flex-direction: column;\n      width: 100%;\n\n      .skd-filter-select,\n      .skd-search-wrap {\n        width: 100%;\n      }\n    }\n\n    .skd-action-btn,\n    .skd-view-btn {\n      font-size: 10px;\n      padding: 4px 8px;\n    }\n\n    .skd-risk-list-item {\n      grid-template-columns: 1fr auto;\n      padding: 10px 12px;\n    }\n\n    .skd-risk-bar-wrap {\n      min-width: 0;\n    }\n  }\n\n  @media (min-width: 1536px) {\n    .skd-ar-stat-label,\n    .skd-ar-stat-value {\n      font-size: 11px;\n    }\n  }\n\n  @container (max-width: 320px) {\n    .skd-ar-stat-content {\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 2px;\n    }\n\n    .skd-ar-stat-value {\n      max-width: 100%;\n      text-align: left;\n      width: 100%;\n    }\n\n    .skd-ar-stat-card {\n      min-height: auto;\n      padding: 8px;\n    }\n  }\n  \n\n  .skd-throughput-items {\n    align-items: center;\n    display: flex;\n    gap: 6px;\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .skd-throughput-item {\n    align-items: center;\n    display: inline-flex;\n    flex-shrink: 0;\n    font-size: 11px;\n    gap: 4px;\n    white-space: nowrap;\n  }\n\n  .skd-throughput-sep {\n    color: inherit;\n    flex-shrink: 0;\n    opacity: 0.7;\n  }\n\n  .skd-throughput-value {\n    font-weight: 600;\n  }\n}\n\n.sales-kpi-dashboard .skd-week-range {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 220px;\n  width: max-content;\n}\n\n.sales-kpi-dashboard .skd-week-range-label {\n  color: #646a8a;\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.sales-kpi-dashboard .skd-week-range-row {\n  align-items: center;\n  display: flex;\n  gap: 6px;\n  width: 100%;\n}\n\n.sales-kpi-dashboard .skd-week-range-select-wrap {\n  background: #fff;\n  border: 1px solid #e3e5ee;\n  border-radius: 4px;\n  flex: 1 1 auto;\n  min-width: 0;\n  position: relative;\n  width: 100%;\n}\n\n.sales-kpi-dashboard .skd-week-range-select-wrap.is-open,\n.sales-kpi-dashboard .skd-week-range-select-wrap:focus-within {\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.sales-kpi-dashboard .skd-week-range-toggle {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  color: #161a3a;\n  cursor: pointer;\n  display: flex;\n  font-size: 13px;\n  height: 32px;\n  padding: 0 4px 0 10px;\n  text-align: left;\n  width: 100%;\n}\n\n.sales-kpi-dashboard .skd-week-range-toggle-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sales-kpi-dashboard .skd-week-range-chevron-icon {\n  fill: #64748b;\n  flex-shrink: 0;\n  height: 18px;\n  pointer-events: none;\n  width: 18px;\n}\n\n.sales-kpi-dashboard .skd-week-range-select-wrap.is-open .skd-week-range-chevron-icon {\n  transform: rotate(180deg);\n}\n\n.sales-kpi-dashboard .skd-week-range-menu {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);\n  left: 0;\n  list-style: none;\n  margin: 4px 0 0;\n  max-height: calc(32px * 5);\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 100%;\n  width: 100%;\n  z-index: 30;\n}\n\n.sales-kpi-dashboard .skd-week-range-option {\n  color: #1e293b;\n  cursor: pointer;\n  font-size: 13px;\n  height: 32px;\n  line-height: 32px;\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.sales-kpi-dashboard .skd-week-range-option:hover {\n  background: #f1f5f9;\n}\n\n.sales-kpi-dashboard .skd-week-range-option.is-selected {\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 600;\n}\n","/* Shared enterprise scrollbar — import into dashboard SCSS roots. */\n\n@mixin dash-scrollbar($size: 6px) {\n  scrollbar-width: thin;\n  scrollbar-color: #9aa8d6 #eef1f8;\n\n  &::-webkit-scrollbar {\n    height: $size;\n    width: $size;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #eef1f8;\n    border-radius: 99px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #9aa8d6;\n    border-radius: 99px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #2f5bea;\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
